export const General = Object.freeze({
  ABBR_ORGAN: "Abrev Órgão",
  ABBR_ORGAN_ISSUING: "Abrev Órgão Emissor",
  ABBR_SECTOR: "Abrev Setor",
  ABBR_SECTOR_ISSUING: "Abrev Setor Emissor",
  ACCESS_LEVEL: "Nível de acesso",
  ACCESS_SUITE: "Acessar Suite",
  ACTION: "Ação",
  ACTIONS: "Ações",
  ACTION_CANCEL: "Ação cancelada",
  ACTIVATE: "Ativar",
  ACTIVE: "Ativa",
  ACTIVE_MASC: "Ativo",
  ADDED_BY: "Adicionado por",
  ADDED_BY_USER: "Adicionado pelo usuário",
  ADDED_BY_PART: "Adicionado pelo Órgão",
  ADDED_ON: "Adicionado em",
  ADDED_ON_UNITY: "Adicionado pela unidade",
  ADDRESS: "Endereço",
  ADD_FILTER: "Adicionar filtro",
  ADD_NEW_INDEX: "Adicionar novo indexador",
  ADD_NEW_LEGAL_REFERENCE: "Adicionar nova referência legal",
  ADD_PHONE: "Adicionar telefone",
  ADD_SECTOR: "Adicionar lotação",
  ADMINISTRATION: "Administração",
  ALERT: "Atenção",
  ALL: "Todos",
  ALL_FEM: "Todas",
  APPENDED_PROCESS: "Processos apensados",
  APPENDED_TO_PROCESS: "Apensado ao processo",
  APPEND_WITHOUT_PROCESS: "Sem processos a apensar",
  APPLICABLE_TO: "Aplicável à",
  APPLY: "Aplicar",
  APPLICABILITY: "Aplicabilidade",
  APPLY_ALL_ORGANS: "Tornar aplicável a todos os órgãos",
  APPLY_FILTER: "Aplicar filtros",
  ARCHIVE: "Arquivar",
  ARCHIVED: "Arquivado",
  ARCHIVE_PROCESS: "Arquivar processo",
  ASKED_BY: "Solicitado por: ",
  ASKED_TO: "Solicitado para: ",
  ASSIGN: "Atribuir",
  ASSIGN_SELF: "Atribuir para mim",
  ASSIGNER_PROFILE: "Perfis atribuidores",
  ASSIGN_RESPONSIBLE: "Atribuir responsável",
  ATTACH: "Anexar",
  ATTACHED_DOCUMENT_EXISTS: "Anexos deste documento",
  ATTACHED_FILE: "Arquivo anexado",
  ATTACHMENT_NAME: "Nome do anexo",
  ATTACH_DOCUMENT: "Anexar documento",
  ATTACH_FILE: "Anexar arquivo",
  AUTHENTICATE: "Validar",
  AUTHENTICATED: "Validado",
  AUTHORIZED: "Autorizado",
  AUTHORIZE_DOE: "Autorizar DOE",
  AUTO_PROCESS: "Tramitar automático",
  AWARE: "Estou ciente",
  BACK_TOP: "Rolar para cima",
  BASIC_DATA: "Dados Básicos",
  BLOCK_DOWN_LEVEL: "Bloquear parametrização de nível inferior",
  BLUR_MENSSAGE_AUTOSAVE: "Clique aqui para salvar rascunho",
  BONDS: "Vínculos",
  BOOKMARKERS: "Marcadores",
  CANCEL: "Cancelar",
  CANCELED: "Cancelou",
  CANCELED_2: "Cancelado",
  CANCELED_DOWNLOAD: "download cancelado",
  CANCELED_GIVEKNOWLEDGE: "Dar ciência cancelado",
  CANCELED_UPLOAD: "upload cancelado",
  CANCEL_ALL: "Cancelar tudo",
  CANCEL_AUTO_PROCESS: "Cancelar tramitação",
  CANCEL_REQUEST: "Cancelar Solicitação",
  CAPACITIES_UNITIES: "Setor(es)/Unidade(s)",
  CAPACITY: "Lotação",
  CATEGORY: "Categoria",
  CATEGORY_LEVEL: "Nível categoria",
  CELL_PHONE: "Celular",
  CELL_PHONES: "Celulares",
  CEP: "Cep",
  CHANGE: "Alterar",
  CHANGE_MANDATORY_SIGNATURE: "Alterar assinaturas obrigatórias",
  CHANGE_PROGRAM_DATE: "Alterou a data",
  CHANGE_PUBLISH_DATE: "Alterou a data registrada",
  CHANGE_REGISTER_DOE: "Alterar data de publicação DOE",
  CHANGE_RESPONSIBLE: "Alterar responsável",
  CHANGE_SCHEDULE: "Alterar programação",
  CHANGE_SCHEDULE_DOE: "Alterar programação DOE",
  CHANGE_SECTOR: "Alterar setor",
  CHANGED_SCHEDULE: "Alterou programação",
  CITY: "Cidade",
  CLICK_HERE: "Clique aqui",
  CLICK_FOR_MORE_INFO: "Clique para saber mais",
  CLICK_TO_ADD: "Clique para adicionar",
  CLONE_CATEGORY: "Clonar categoria",
  CLONE_DOCUMENT: "Clonar Documentos",
  CLONE_DOCUMENT_DESCRIPTION:
    "Permite gerar uma cópia de um documento criado no Suite que esteja listado na aba Documentos deste processo",
  CLONE_MODELS: "Clonar modelos",
  CLONE_SUBCATEGORY: "Clonar subcategoria",
  CLOSE: "Fechar",
  CNPJ: "CNPJ",
  CODE: "Código",
  CODE_CATEGORY: "Código da categoria",
  CODE_SUBCATEGORY: "Código da subcategoria",
  CONFIDENTIAL_SECRECY: "Sigiloso",
  COLLAPSE_MENU: "Recolher menu",
  COLOR: "Cor",
  COMPLEMENT: "Complemento",
  CONFIG: "Configurações",
  CONFIG_SINGULAR: "Configuração",
  CONFIRM: "Confirmar",
  CONSULT_PROCESS_LABEL: "Consultar processos no Suite ou ViProc",
  CONTINUE: "Continuar",
  CORE_PROTOCOL: "Protocolo Central",
  CORE_PROTOCOL_ATUAL: "Protocolo central atual",
  CORPORATE_PROCESS: "Processo corporativo",
  COVER: "Capa",
  COVERAGE: "Abrangência",
  CPF: "CPF",
  CPF_CNPJ: "CPF/CNPJ",
  CREATE: "Criar",
  CREATED_BY: "Criado por",
  CREATE_CATEGORY: "Criar Categoria",
  CREATE_DOCUMENT: "Criar documento",
  CREATE_SUBCATEGORY: "Criar Subcategoria",
  COPIED_URL: "URL copiada",
  CONFIDENTIAL_PERIOD: "Prazo do sigilo",
  CONFIDENTIAL_PERIOD_UPDATED: "Prazo do sigilo alterado com sucesso",
  CURRENT_CAPACITY: "Unidade atual",
  CURRENT_ENTITY_UNIT: "Órgão/Unidade atual",
  CURRENT_PAGE: "Página atual",
  CURRENT_PART: "Órgão atual",
  CURRENT_STATUS: "Situação atual",
  DATE: "Data",
  DATE_PROCESSED: "Data de tramitação",
  DATES: "Datas",
  DATE_CHANGE: "Alteração de data",
  DAYS: "Dias",
  DECLINE: "Recusar",
  DECLINE_DOE: "Recusar DOE",
  DECLINE_PUBLICATION: "Recusar publicação DOE",
  DECLINE_REQUEST: "Recusar Solicitação",
  DELETE: "Excluir",
  DESCRIPTION: "Descrição",
  DESCRIPTION_CATEGORY: "Descrição da categoria",
  DESCRIPTION_SUBCATEGORY: "Descrição da Subcategoria",
  DESTINATION_PROCEDURE: "Para",
  DETAILING: "Detalhamento",
  DETAILS: "Detalhes",
  DIGITAL_SIGNATURE: "Assinatura com certificado digital",
  DISABLE: "Desativar",
  DISABLE_NOTIFICATION: "Desativar notificação",
  DISFAVOR: "Desfavoritar",
  DISPATCH: "Despacho",
  DISTRICT: "Bairro",
  DOCUMENT: "Documento",
  DOCUMENTS: "Documentos",
  DOCUMENTS_ATTACHED: "Documentos anexados",
  DOCUMENT_AUTHENTICATED_BY: "Documento validado por",
  DOCUMENT_CODE: "Código documento",
  DOCUMENT_MODELS: "Modelos de documentos",
  DOCUMENT_NAME: "Nome do documento",
  DOCUMENT_NUMBER: "Documento Nº",
  DOCUMENT_NOT_FOUND:
    "Este processo não está mais disponível para realizar ações.",
  DOCUMENT_OFFICIAL_NUMBER: "Documento Oficial Nº",
  DOCUMENT_TYPE: "Tipo de documento",
  DOCUMENT_WITHOUT_EFFECT: "Documento sem efeito",
  DOCUMENT_WITHOUT_HISTORY: "Sem histórico do Documento",
  DOC_SIGNED: "O documento foi assinado!",
  DOE: "DOE",
  DOE_CAN_PROCESS_FILTER: "Aptos a tramitar (DOE)",
  DOE_DOCUMENT: "Documento DOE",
  DOE_PUBLISH: "Publicar DOE",
  DOE_SITUATION: "Situação DOE",
  DOUBT: "Dúvidas?",
  DOUBT_TEXT: "Clique aqui para acessar a Central de Ajuda",
  DOWNLOAD: "Baixar",
  DOWNLOAD_PRINTABLE_VERSION: "Baixar versão para impressão",
  DOWNLOAD_SIGNED_DOCUMENT: "Baixar arquivo digital",
  DUE: "Prazo",
  EDIT: "Editar",
  EDITABLE_DOCUMENTS: "Documentos Editáveis",
  EDITABLE_FILES: "Arquivos Editáveis",
  EDIT_CATEGORY: "Editar Categoria",
  EDIT_PERMISSION: "Editar permissão",
  EDIT_SUBCATEGORY: "Editar Subcategoria",
  EDIT_USER: "Editar Usuário",
  EDIT_LEGAL_REFERENCE: "Editar referência legal",
  ELECTRONIC_SIGNATURE: "Assinatura Avançada",
  EMAIL: "E-mail",
  EMAILS: "E-mails",
  EMPTY_FIELD_REQUIRED: "Preencha todos os campos requeridos",
  ESTIMATED: "estimado",
  EXPAND_MENU: "Expandir menu",
  EXPIRES_IN: "Expira em",
  EXPORT: "Exportar",
  EXPORT_PDF: "Exportar PDF",
  EXTERNAL: "Externa",
  EXTERNAL_GIVE_SCIENCE: "Dar ciência externo",
  EXTERNAL_PROCESS: "Processo externo",
  EXTERNAL_PROCESSING: "Tramitação Externa",
  EXTERNAL_USER: "Usuário externo",
  EXTERN_SIGNATURE: "Assinatura Externa",
  FAIL_SEARCH_CPF:
    'O interessado buscado não está cadastrado no Guardião, Acesso Cidadão e/ou como interessado em outro processo do Suite. <a target="_blank" rel="noopener help" class="is-underlined has-text-color-6" href="https://drive.google.com/file/d/18KyvRXnKrkcJI9k7geekoNIeYIBSLTaz/view?usp=drive_link">Clique aqui para verificar as soluções alternativas</a>.',
  FAIL_SEND: "Falha no envio",
  FAVOR: "Favoritar",
  FIELD_NAME: "Nome do campo",
  FILE: "Arquivo",
  FILE_RECEIVED: "Arquivo recebido",
  FILTER: "Filtro",
  FILTERS: "Filtros",
  FINALIST_PROCESS: "Processo finalístico",
  FIND_YOUR_PROCESS:
    "Encontre processos pesquisando pelo número do protocolo, nome, assunto ou número do processo do ViProc",
  FOLLOW_SUBSCRIPTION_ORDER: "Seguir ordem de assinatura",
  FORWARD: "Encaminhar",
  FORWARDED: "Encaminhado",
  FROM: "De",
  GENRE: "Gênero",
  GIVE_BACK: "Devolver",
  GIVE_KNOWLEDGE: "Dar ciência",
  GIVE_KNOWLEDGE_COVER: "Dar ciência da capa",
  GIVE_KNOWLEDGE_DOCUMENT: "Dar ciência documento",
  GIVE_KNOWLEDGE_PROCESS: "Dar ciência do processo",
  GO_TO_DOCUMENT: "Ir para aba documentos",
  GO_TO_SITE: "Ir para o site",
  HELP: "Ajuda",
  HISTORY_DOCUMENT: "Histórico do documento",
  IN_PERSON_BIDDING: "Licitação presencial",
  INACTIVE: "Inativa",
  INACTIVE_MASC: "Inativo",
  INCLUDE: "Incluir",
  INCLUDE_LEGAL_REFERENCE: "Incluir referência legal",
  INDEXER: "Indexador",
  INDEX_CATEGORY: "Indexadores da categoria",
  INDEX_SUBCATEGORY: "Indexadores Subcategoria",
  INDIVIDUAL: "Individual",
  INFORMATION: "Informação",
  INFO_MANDATORY_SIGNATURE: "Informar assinaturas obrigatórias",
  INICIAL_PETITION: "Petição inicial",
  INTERESTED: "Interessado",
  INTERESTED_PLURAL: "Interessados",
  INTERESTED_GENERIC: "Interessado(s)",
  INTERNAL: "Interna",
  INTERNAL_PROCESSING: "Tramitação Interna",
  IMMEDIATE: "Imediato",
  JUSTIFICATION: "Justificativa",
  KEYWORDS: "Palavras-chave",
  LABEL_LOW_LEVEL: "Responsável pelo nível inferior",
  LABEL_SUBJECT_TYPE: "Selecione o tipo de assunto",
  LAST_CHANGE: "Última alteração",
  LEGAL_NATURE: "Natureza jurídica",
  LEGAL_REFERENCE: "Referência Legal",
  LEGAL_REFERENCE_ACCESS: "Referência legal (do nível de acesso)",
  LENGTH_OF_STAY: "Tempo de permanência",
  LEARN_MORE: "Saiba mais",
  LISTED_UNITIES: "unidade(s) listada(s)",
  LOG_OUT: "Sair",
  MAKE_SUBJECT: "Tornar um assunto",
  MANAGE_NOTIFICATION: "Gerenciar notificações",
  MANAGE_UNITY: "Gestão de unidades",
  MANDATORY: "Obrigatório",
  MANDATORY_SIGNATURE: "Assinaturas Obrigatórias DOE",
  MARKER: "Marcador",
  MARKERS: "Marcadores",
  MAX_SIZE: "Tamanho Máximo",
  MERGE: "Juntada",
  MERGE_DOCUMENTS: "Juntada de documentos",
  MERGE_PROCESS: "Juntada de processos",
  MIGRATE: "Migrado",
  MODELS: "Modelos",
  MODELS_EXISTED: "Modelos existentes",
  MSG_RESEND_SIGNATURE:
    "Tem certeza que deseja reenviar as solicitações de assinatura",
  MY_USER_AREA: "Minha área de usuário",
  NAME: "Nome",
  NAME_CATEGORY: "Nome da categoria",
  NAME_SEARCH: "Pesquise por nome",
  NAME_SOCIAL_REASON: "Nome/Razão Social",
  NAME_SUBCATEGORY: "Nome da subcategoria",
  NEW_DOCUMENT: "Novo documento",
  NEW_INDEXER: "Novo Indexador",
  NEW_LEGAL_REFERENCE: "Nova referência legal",
  NEW_PROCESS: "Novo Processo",
  NEW_REGISTRY: "Cadastro",
  NEXT_PAGE: "Próxima página",
  NO: "Não",
  NOTES: "Observação",
  NOTIFICATION: "Notificação",
  NOTIFICATIONS: "Notificações",
  NOT_USED_BOOKMARKS: "Exibir somente marcadores não utilizados",
  NO_EFFECT: "Tornar sem efeito",
  NO_RESULTS: "Nenhum Resultado!",
  NUMBER: "Número",
  NUP: "NUP",
  NUP_GENERATED_PROCESSED: "NUP será gerado após a tramitação",
  OBLIGATORY: "(obrigatório)",
  OBSERVATION_DOE_PUBLISH: "Observações sobre a publicação no DOE",
  OCCURENCY_FILE: "Folha de ocorrência",
  OCCURENCY_FILE_PLURAL: "Folha de ocorrências",
  OFFICIAL_MODELS: "Modelos oficiais",
  OK: "Ok",
  ONLY_CSV_FILE: "Somente arquivos CSV",
  OPENING_DATE: "Data de abertura",
  OPENING_PART_UNIT: "Órgão/Unidade de abertura",
  OPENING_PROCESS_OUT_SYSTEM:
    "Permitir a abertura de processo apenas via integração",
  OPENING_UNIT: "Unidade de abertura",
  OPTIONAL: "(opcional)",
  ORDER_BY: "Ordenar por:",
  ORDER_TO: "Ordem por",
  ORGAN: "Órgão",
  ORGAN_ENTITY: "Órgão/Entidade",
  ORGAN_ENTITY_UNITY: "Órgão/Entidade/Unidade",
  ORGAN_ISSUING: "Órgão Emissor",
  ORGAN_UNIT: "Órgão/Unidade",
  ORIGIN: "Origem",
  ORIGIN_OF_PROCEDURE: "Origem do trâmite",
  ORIGIN_PROCEDURE: "De",
  ORIGIN_UNITY: "Unidade de origem",
  OVERVIEW: "Visão geral",
  PAGE: "Página",
  PARTIALL_SUBSCRIPTION: "Parcialmente Assinado",
  PARTICIPATE: "Compartilhe",
  PASSWORD: "Senha",
  PASSWORD_GUARDIAN: "Senha do Guardião",
  PAST_DUE_PROCESS: "vencido",
  PAST_DUE_PROCESS_PLURAL: "vencidos",
  PENDING: "Pendências",
  PER: "Por",
  PERIOD: "Período",
  PERIOD_AUTHORIZATION: "Período de Autorização",
  PERIOD_CREATED: "Período de Cadastro (Abertura)",
  PERIOD_PROGRAMATION: "Período de Programação",
  PERIOD_PUBLISH: "Período de Publicação",
  PERIOD_RECEIVED: "Período de recebimento",
  PERIOD_REFUSE: "Período de Recusa",
  PERMISSION: "Permissão",
  PERMISSIONS: "Permissões",
  PERMISSIONS_MANAGEMENT_BY_PROFILE: "Gestão de permissões por perfil",
  PER_PAGE: "Por página",
  POSITION: "Cargo",
  PREVIOUS_PAGE: "Página anterior",
  PREVIOUS_SCHEDULE: "Programação prévia",
  PRIORITY_LEVEL: "Nível de prioridade",
  PROBLEM_VIEW_PDF: "Problemas para visualizar PDF?",
  PROCEDURES: "Tramitações",
  PROCEED: "Tramitar",
  PROCESS: "Processo",
  PROCESS_NOT_FOUND:
    "Este processo não está mais disponível para realizar ações.",
  PROCESSED: "Tramitado",
  PROCESSED_NUPS_INFO: "Os seguintes processos foram tramitados",
  PROCESSING: "Tramitadora",
  PROCESS_ANALISIS_TIME: "Processos em análise por tempo",
  CANCELED_PROCESS: "Processo cancelado",
  PROCESS_DOCUMENTS: "Documentos do processo",
  PROCESS_MAX_SIZE: "Tamanho total do processo",
  PROCESS_NEW_ACTIONS: "Novas ações realizadas no processo",
  PROCESS_PAGE: "Página do processo",
  PROCESS_PAINEL: "Painel de Processos",
  PROCESS_PLURAL: "Processos",
  PROCESS_REGISTERED: "Cadastrado via sistema",
  PROCESS_SIZE: "Tamanho do processo",
  PROFILE: "Perfil",
  PROFILES: "Perfis",
  PROGRAMMED: "Programou",
  PROGRAMMED_DATE: "Data programada",
  PROTOCOL_OFTHE: "Processo do(a)",
  PROTOCOL_REFERENCE: "Número de processo externo",
  PUBLICATED: "Publicado",
  PUBLICATION_DATE: "Data da publicação",
  PUBLICATION_DOE: "Publicação DOE",
  PUBLISH: "Publicar",
  PUBLISHED: "Registrou",
  REASON: "Motivo",
  REASON_APPEND: "Digite a motivação da apensação",
  REASON_ARCHIVE: "Motivo do arquivamento",
  REASON_FOR_CHANGE: "Motivo da alteração",
  REASON_JOIN: "Digite a justificativa da juntada",
  REASON_UNARCHIVE: "Motivo do desarquivamento",
  RECEIVED: "Recebido",
  RECEIVER: "Receptora",
  RECORD: "Registros",
  RECORD_PLURAL: "Registro(s)",
  RECORDS_FOR_PAGE: "Registros por página",
  REFERENCE_PROCESS: "Processos de referência",
  REFUSED: "recusou",
  REFUSED_SUBSCRIPTION: "Recusado",
  REGISTER_DOE: "Registrar DOE",
  REGISTRATION_ORGAN: "Órgão de cadastro",
  RELOAD: "Recarregar",
  REMOVE: "Remover",
  REMOVE_ALL: "Excluir todos",
  REMOVE_PHONE: "Remover telefone",
  REQUEST_AGAIN: "Solicitar novamente",
  REQUEST_SIGNATURE_EXTERNE: "Solicitar assinatura de assinante externo",
  REQUEST_SUBSCRIPTION: "Solicitar assinatura",
  REQUIRED_ACCESS_LEVEL: "Digite o nível de acesso",
  REQUIRED_ATTACH: "É necessário pelo menos um anexo de documento",
  REQUIRED_FIELDS: "Campos obrigatórios",
  REQUIRED_PRIORITY_LEVEL: "Digite o nível de prioridade",
  REQUIRED_PROCESS_TO_APPEND: "É necessário selecionar um processo a apensar",
  REQUIRED_USER_RESPONSABLE:
    "É necessário ser responsável pelo processo apensado",
  REQUIRED_DIFFERENCE_NUP: "Não é possível apensar o processo a ele mesmo.",
  RESPONSIBLE: "Responsável",
  RETURN: "Voltar",
  SAVE: "Salvar",
  SAVE_DRAFT: "Salvar rascunho",
  SCHEDULE: "Programar",
  SCHEDULE_CANCELLATION: "Cancelamento da programação",
  SCHEDULE_DATE: "Data de programação",
  SCHEDULE_DOE: "Programar DOE",
  SCHEDULE_PUBLICATION: "Programar publicação",
  SCHEDULE_PUBLICATION_DOE: "Programar publicação DOE",
  SEARCH: "Buscar",
  SEARCH_DATE: "Data da consulta",
  SEARCH_EXIST_CATEGORY: "Digite para pesquisar uma categoria existente",
  SECONDARY_CAPACITY: "Lotação Secundária",
  SECTOR: "Setor",
  SECTOR_ISSUING: "Setor Emissor",
  SEE_ALL_NUPS: "Ver todos os NUPS",
  SELECET_PUBLICATION_DATE: "Selecione a data de publicação",
  SELECTE_SCHEDULE_DATE: "Selecione a data de programação",
  SELECT_AN_REASON: "Selecione um motivo",
  SELECT_CATEGORY: "Selecione uma categoria",
  SELECT_CATEGORY_EXISTING: "Digite para pesquisar uma categoria existente",
  SELECT_CERTIFICATE_SIGN: "Selecione um certificado para assinar",
  SELECT_DOCUMENT_TYPE: "Pesquisar tipo de documento",
  SELECT_FILTER: "Selecione um filtro",
  SELECT_LEVEL: "Selecione um nível de acesso",
  SELECT_LEVEL_PERIOD: "Selecione o prazo de sigilo",
  SELECT_ORGAN_ENTITIES: "Aplicável aos órgãos/entidades",
  SELECT_PARENT_CATEGORY: "Selecione uma categoria válida",
  SELECT_PART: "Selecione um Órgão/Entidade/Unidade",
  SELECT_PRIORITY: "Selecione um nível de prioridade",
  SELECT_SUBCATEGORY: "Selecione uma subcategoria",
  SELECT_SUBCATEGORY_EXISTING:
    "Digite para pesquisar uma subcategoria 1 existente",
  SELECT_SUBJECT: "Selecione um assunto",
  SELECT_TO: "Selecione pelo menos um órgão válido",
  SELECT_TYPE: "Selecione um tipo",
  SEND_FEEDBACK: "Envie sua opinião",
  SEND_TO_DOE: "Enviar para DOE",
  SENT_TO_PUBLISH: "Enviado para publicação",
  SIGN: "Assinar",
  SIGN_WITH: "Assinar com",
  SIGNATURES: "Assinaturas",
  SIGNATURES_MADE: "Assinaturas realizadas",
  SIGNATURES_PENDING: "Assinaturas pendentes",
  SIGNATURES_REFUSED: "Assinaturas recusadas",
  SIGNATURE_HISTORY: "Histórico de assinaturas do documento",
  SIGNATURE_STATES: "Situação assinaturas",
  SIGNATURE_WITH: "Assinatura com",
  SIGNED: "Assinado",
  SIGN_BATCH: "Assinatura em lote com",
  SITE: "Site",
  SIZE: "Tamanho",
  SMS: "SMS",
  STATE: "Estado",
  STATUS: "Situação",
  STATUS_NAME: "Status",
  SUBCATEGORY: "Subcategoria",
  SUBJECT: "Assunto",
  SUBJECT_CODE: "Assunto Código",
  SUBJECT_CATEGORY: "Assunto/Categoria",
  SUBJECT_PLURAL: "Assuntos",
  SUBJECT_TYPE: "Tipo de assunto",
  SUBMIT: "Enviar",
  SUBSCRIBER: "Assinante",
  SUBSCRIPTION_REQUEST: "Solicitação de assinatura",
  SUCCESS_CREATED: "Criado com sucesso",
  SUCCESS_SEND: "Sucesso no envio",
  SUCCESS_UPDATED: "Atualizado com sucesso",
  SUITE: "Suite",
  TELEPHONE: "Telefone",
  TELEPHONES: "Telefones",
  THIS_DOC_IS_ALREADY_NO_EFFECT: "Este documento já está sem efeito",
  TIME: "Tempo",
  TIMELINE: "Linha do Tempo",
  TO: "Para",
  TOKEN_FAILURE: "Falha na leitura do Token",
  TOTAL_PROCESS_TIME: "Tempo total do processo (ativo):",
  TO_VIEW: "Visualizar",
  TO_VIEW_COVER: "Visualizar capa",
  TRY_AGAIN: "Tentar novamente",
  TYPE: "Tipo",
  TYPE_DOCUMENT: "Tipo do documento",
  TYPE_DOCUMENT_NAME: "Digite o nome do documento",
  TYPE_IT_LEGAL_REFERENCE: "Digite para pesquisar referência legal",
  TYPE_IT_SEARCH: "Digite para pesquisar",
  TYPE_NAME: "Digite o nome",
  TYPE_NATURE: "Tipo de Natureza",
  UF: "UF",
  UNAPPEND: "Desapensar",
  UNARCHIVE: "Desarquivar",
  UNARCHIVED: "Desarquivado",
  UNARCHIVE_PROCESS: "Desarquivar processo",
  UNIQUE_ALERT: "Filtro já selecionado",
  UNITY: "Unidade",
  UNMAPPED_PROTOCOL: "Protocolo não mapeado",
  UPDATED_AT: "Alterado em",
  UP_UNTIL: "Até",
  URL: "URL",
  USER: "Usuário",
  USERS: "Usuários",
  VIEW_DIGITAL_FILE: "Visualizar arquivo digital",
  VIEW_DISABLED: "Exibir inativas",
  VIEW_DOCUMENT: "Visualizar documento",
  VIEW_PROCESS: "Visualizar Processo",
  VIEW_SECTOR_AND_SUBORDINATES: "Visão do Setor e Subordinadas",
  WARNING: "Aviso",
  WISH_TO_CONTINUE: "Deseja continuar?",
  WITHOUT_CAPACITY: "Sem lotação",
  WITHOUT_STAKEHOLDER: "Preencha o interessado",
  WITHOUT_SUBJECT: "Preencha o assunto",
  WITHOUT_TO: "Preencha o para",
  WITHOUT_USER_ACCESS: "Usuário sem acesso a ação",
  WITHOUT_USER_MAIL: "Usuário sem e-mail",
  YES: "Sim",
  YOU_DONT_HAVE_THIS_PERMISSION: "Você não possui a permissão necessária",
  YOU_DONT_HAVE_PERMISSION_TO_CHANGE_PROFILE:
    "Você não possui permissão para atribuir ou remover este perfil",
  YOU_HAVE_ALREADY_SIGNED_THIS_DOC: "Você já assinou este documento",
  PLACEHOLDER: {
    DESCRIPTION_ATTACH_FILE:
      "Anexe imagens ou arquivos que possam ajudar no seu comentário",
    DOCUMENT_NAME: "Digite o nome do documento...",
    EDIT_BOOKMARK_NAME: "Nome do marcador",
    EMPTY_OBSERVATION: "Digite uma observação",
    EMPTY_ORGAN_CAPACITY: "Digite para pesquisar Órgão/Unidade",
    FEEDBACK_DESCRIPTION_PLACEHOLDER: "Descreva o seu comentário.",
    FEEDBACK_REFER_PLACEHOLDER: "Selecione a área do sistema",
    FEEDBACK_TYPE_PLACEHOLDER: "Selecione o tipo",
    INSERT_CATEGORY_DESCRIPTION: "Insira a descrição da categoria",
    INSERT_CATEGORY_NAME: "Insira o nome da categoria",
    INSERT_COMPLEMENT: "Insira o complemento",
    INSERT_KEYWORDS: "Insira palavras-chave",
    INSERT_PHONE: "Insira o telefone",
    INSERT_SUBCATEGORY_DESCRIPTION: "Insira a descrição da subcategoria",
    INSERT_SUBCATEGORY_NAME: "Insira o nome da subcategoria",
    INTERESTED: "Digite para pesquisar interessado",
    JOINT_MOTIVATION: "Digite a justificativa da juntada",
    KEYWORDS: "Palavras-chave",
    MODEL_NAME: "Digite o nome do modelo do documento",
    MODEL_NAME_REDUCED: "Digite o nome reduzido do modelo",
    NAME_INDEXER: "Escreva o nome do indexador",
    TYPE_OBSERVATION: "Digite uma observação",
    PERMISSION_NAME: "Nome da permissão",
    RECEIVE_OPINION_EMAIL: "Receber a sua opinião por Email",
    REFERENCE_PROCESS: "Número de processo externo",
    RETURN_ORIGIN: "Digite a justificativa para o despacho à origem",
    SEARCH_BOOKMARKER: "Digite para pesquisar marcadores",
    SEARCH_BY_NUP_NAME_SUBJECT: "Pesquise por NUP, nome ou assunto",
    SEARCH_BY_ORGAN_ORIGIN_DESTINY:
      "Pesquise por órgão/unidade de origem ou de destino da migração",
    SEARCH_CAPACITY: "Digite para pesquisar unidade",
    SEARCH_CAPACITY_PROTOCOL:
      "Digite para pesquisar unidade de protocolo central",
    SEARCH_CATEGORY: "Digite para pesquisar categoria",
    SEARCH_CATEGORY_INDEX: "Pesquise os indexadores da categoria",
    SEARCH_FOR_ORGAN_ENTITY: "Pesquise por órgão/entidade",
    SEARCH_FOR_ORGAN: "Digite para pesquisar por órgão",
    SEARCH_FOR_UNITY: "Digite para pesquisar por unidade",
    SEARCH_IN: "Buscar em",
    SEARCH_INDEXER: "Digite para pesquisar indexador",
    SEARCH_LEGISLATION: "Pesquise uma legislação",
    SEARCH_NUP: "Pesquisar NUP",
    SEARCH_ORGAN: "Digite para pesquisar órgão",
    SEARCH_ORGAN_ENTITY: "Digite para pesquisar Órgão/Entidade",
    SEARCH_ORGAN_ENTITY_UNITY:
      "Digite para pesquisar um órgão/entidade/unidade",
    SEARCH_PROCESS:
      "Pesquise processos por NUP, nome, assunto ou número do ViProc",
    SEARCH_PROCESS_REDUCED: "Pesquise processos",
    SEARCH_SUBCATEGORY: "Digite para pesquisar subcategoria",
    SEARCH_SUBCATEGORY_INDEX: "Pesquise os indexadores da subcategoria",
    SEARCH_BY_SUBJECT: "Digite para pesquisar por assunto",
    SEARCH_USER: "Pesquise por nome, CPF ou órgão",
    SEARCH_USERNAME: "Digite para pesquisar usuário por nome",
    SECTOR: "Digite para pesquisar Setor/Órgão",
    SELECT_CONFIGURATION: "Selecione uma configuração",
    SELECT_COVERAGE: "Selecione a abrangência",
    SELECT_PERIOD_END: "Selecione ou digite a data final",
    SELECT_PERIOD_START: "Selecione a data de início",
    SELECT_SITUATION: "Selecione uma situação",
    SELECT_SUBJECT_TYPE: "Selecione tipo de assunto",
    SUBJECT: "Digite para pesquisar o assunto",
    TYPING_CORPORATE_NAME: "Digite o nome/razão social",
    TYPE_IT_INCLUDE: "Digite para pesquisar NUP",
    TYPE_THE_MAIL: "Digite o e-mail",
    TYPE_SEARCH_FULL_USER_UNIT:
      "Digite para pesquisar usuário lotado na unidade",
    TYPE_SEARCH_PROCESS_REFERENCE: "Digite o NUP do processo externo",
    TYPE_TO_SEARCH: "Digite para realizar a busca.",
    UNAPPEND_JUSTIFICATION:
      "Detalhe a justificativa para desapensação do processo.",
    WRITE_LEGAL_REFERENCE: "Insira a referência legal"
  },
  TEXTS: {
    ACCESS_PROCESS_QRCODE: "Acesse o processo através do QR Code.",
    ACTION_FINISHED: "Ações concluídas",
    ACTION_QUANTITY: "Realizando ações em (QUANTITY) itens",
    ACTION_QUANTITY_SINGULAR: "Realizando ação em (QUANTITY) item",
    ADD_STAKEHOLDER_USER: "Cadastrar novo interessado",
    ALERT_FILE_UPLOAD:
      "Obs: Arquivos PDF com tamanho superior a 30 MB não poderão ser assinados.",
    ALERT_FILE_UPLOAD_EDITABLE:
      "Obs: Arquivos com tamanho superior a 30 MB não poderão ser assinados.",
    ALERT_RESTPKI_CERTIFICATE:
      "Certificado inválido. Para assinar o documento é necessário um certificado ICP-Brasil",
    ALERT_RESTPKI_CERTIFICATE_INVALID:
      "Não é possível acessar pois o certificado está expirado ou inválido.",
    ALERT_RESTPKI_CERTIFICATE_INVALID_SIGNATURE:
      "Não é possível assinar pois o certificado está expirado ou inválido.",
    AND_OTHERS: "e Outros",
    ATTACH_DOCUMENTS_PROCESS: "Anexar documentos",
    ATTACH_JOINT: "Documento anexado ao processo! (Incluído na aba documentos)",
    AUTHORIZED_PUBLICATION: "autorizou a publicação no DOE",
    AUTHORIZE_PUBLICATION_DOE:
      "Tem certeza que deseja autorizar a publicação deste(s) documento(s) no DOE?",
    AUTOMATIC_PROCESSING: "Tramitação automático",
    AUTOMATIC_PROCESSING_SECOND: "Tramitação automática",
    AUTOMATIC_PROCESSING_CANCELLED: "Cancelamento de tramitação automático",
    AWAITING_CONTENT: "Aguardando conteúdo...",
    AWAITING_SIGNATURE_FROM: "Aguardando assinatura de",
    BETA_TAG: "Ambiente de treinamento",
    BLOCK_GIVE_KNOWLEDGE:
      "Processo restrito, você não possui permissão para dar ciência.",
    CANCELED_SUBSCRIPTION_REQUEST: "Cancelamento da(s) assinatura(s) realizada",
    CLICK_ASSIGN_SELF: "Clique para atribuir este(s) processo(s) a você.",
    CONFIDENTIAL_RESPONSIBLE_WARNING:
      "Você não possui permissão para atribuir processos sigilosos.",
    CONFIDENTIAL_ARCHIVE_WARNING:
      "Você não possui permissão para arquivar processos sigilosos",
    CONFIDENTIAL_DESARCHIVE_WARNING:
      "Você não possui permissão para desarquivar processos sigilosos",
    CONFIDENTIAL_PERIOD:
      "Para processos classificados como sigilosos, é obrigatório informar o prazo de sigilo da informação, conforme previsto na Lei Estadual de Acesso à Informação nº 15.175/2012.",
    CONFIDENTIAL_VIEW_WARNING:
      "Você não possui permissão para visualizar documentos e processos sigilosos",
    CONFIRM_CANCEL_DOC: "Tem certeza que deseja cancelar a edição do documento",
    CONFIRM_CANCEL_REQUEST:
      "Tem certeza que deseja cancelar a solicitação de assinatura",
    CONFIRM_DELETE_MARKED: "Tem certeza que deseja excluir este marcador",
    CONFIRM_DELETE_NOTIFICATION:
      "Tem certeza que deseja excluir essa notificação?",
    CONFIRM_DELETE_NOTIFICATIONS:
      "Tem certeza que deseja excluir essas notificações?",
    CONFIRM_DISABLE_CAPACITY_WITH_CHILDREN:
      "Ao desabilitar essa unidade todas as suas subordinadas também serão desabilitadas. Deseja prosseguir com a ação?",
    CONFIRM_DISABLE_SUBCATEGORY_WITH_CHILDREN:
      "Ao desabilitar essa subcategoria 1 todas as suas subcategorias 2 também serão desabilitadas. Deseja prosseguir com a ação?",
    CONFIRM_DISABLE_SUBJECT: "Tem certeza que deseja desativar esse assunto?",
    CONFIRM_DISABLE_SUBJECTS_WITH_CHILDREN:
      "Ao desabilitar essa categoria todas as suas subcategorias também serão desabilitadas. Deseja prosseguir com a ação?",
    CONFIRM_CONTINUE_IGNORE_JOINT:
      "Tem certeza que deseja tramitar este processo? Existe uma <strong>juntada de documentos</strong> em andamento.",
    CONFIRM_ENABLE_CAPACITY_WITH_CHILDREN:
      "Essa unidade possui subordinadas, deseja habilitá-las também?",
    CONFIRM_ENABLE_SUBCATEGORY_WITH_CHILDREN:
      "Essa subcategoria 1 possui subcategorias 2, deseja habilitá-las também?",
    CONFIRM_ENABLE_SUBJECTS_WITH_CHILDREN:
      "Essa categoria possui subcategorias, deseja habilitá-las também?",
    CONFIRM_EXCLUDE_SUBJECT: "Tem certeza que deseja excluir esse assunto?",
    CONFIRM_JOINT_DOCUMENT_GO_OUT:
      'Tem certeza que deseja sair da tela?<br> Para juntar o(s) documento(s) no processo, é necessário<br> <strong>clicar em "Salvar"</strong>',
    CONFIRM_MARK_ALL_READ: "Tem certeza que deseja marcar tudo como lido",
    CONFIRM_MARK_READ:
      "Tem certeza que deseja marcar as notificações selecionadas como lidas?",
    CREATED_CATEGORY: "Categoria cadastrada com sucesso!",
    CREATED_SUBCATEGORY: "Subcategoria 1 cadastrada com sucesso!",
    CREATED_SUBCATEGORY_2: "Subcategoria 2 cadastrada com sucesso!",
    CREATE_DISPATCH_DOC: "Criar folha de despacho",
    CREATE_SOLICITATION_DOC: "Criar documento de solicitação",
    DECLINED_SIGNATURE: "assinatura recusada",
    DECLINED_SIGNATURES: "assinaturas recusadas",
    DEFAULT_FORWARD_TEXT:
      "O presente processo foi encaminhado a esta unidade para análise e providências cabíveis.",
    DEFAULT_RETURN_TEXT:
      "Informamos que a análise deste processo não é de competência desta unidade, motivo pelo qual devolvemos para encaminhamento à área competente.",
    DELETE_SIGNED_REQUEST:
      "Essa ação irá excluir as assinaturas pendentes e realizadas no Suite. Deseja continuar essa ação",
    DESCRIPTION_EXTENAL_NUP:
      "Número de protocolo de um processo de sistema externo ou do ViProc com assunto relacionado a este processo.",
    DESCRIPTION_INDEXERS_NOT_REMOVE_PARENT:
      "Os indexadores herdados da categoria não podem ser editados e nem excluídos, por isso não possuem a possibilidade de edição.",
    DESCRIPTION_INTERESTED:
      "Os Interessados são partes interessadas do processo, podendo ser pessoa física, pessoa jurídica ou unidade organizacional do Poder Executivo do Estado do Ceará.",
    DESCRIPTION_LEGAL_REFERENCE:
      "A Referência Legal é obrigatória para os níveis de acesso “restrito” e “sigiloso”. Neste campo, deve constar a fundamentação legal que provê embasamento jurídico para o nível selecionado.",
    DESCRIPTION_LEGAL_REFERENCE_MODAL:
      "Este campo é obrigatório e, para processos “sigilosos” com informações classificadas em grau de sigilo (reservado, secreto e ultrassecreto), é necessário também informar o inciso da Portaria CGAI nº 01/2016 ou o número da reunião de deliberação pelo Comitê Gestor de Acesso à Informação - CGAI, que fundamenta o nível selecionado. <a href='https://docs.google.com/spreadsheets/d/1D_CtBWAQth6w4FTutpCjSeAQSVix4YeQFneghvRzAeo/edit?usp=sharing' target='_blank' rel='noopener search external' class='is-link is-underlined'>Clique aqui</a> para saber mais.",
    DESCRIPTION_NUP:
      "NUP(s) de processo(s) do Suite com assunto relacionado a este processo que tramitará de forma independente",
    DESCRIPTION_ORGAN_UNITY:
      "Esse campo deve ser preenchido apenas se as informações de cadastro forem referentes a unidade do Órgão/Entidade.",
    DESCRIPTION_TO:
      "Para alterar este campo, é necessário excluir o documento de (TYPE) criado.",
    DETAIL_REASON_ARCHIVED: "Detalhe o motivo do arquivamento",
    DETAIL_REASON_REFUSED: "Detalhe o motivo da recusa",
    DETAIL_REASON_UNARCHIVED: "Detalhe o motivo do desarquivamento",
    DETAIL_SIGNATURE_HELP:
      "Para assinar o documento é necessário possuir um <a href='https://suite.seplag.ce.gov.br/?p=264' target='_blank' rel='search external' class='is-link is-underlined'>certificado digital IPC-Brasil</a> e ter instalado a extensão <a href='https://suite.seplag.ce.gov.br/?p=266' target='_blank' rel='search external' class='is-link is-underlined'>Lacuna WebPKI</a> no seu navegador.",
    DISABLE_NOTIFICATION:
      "O recebimento da notificação (NOTIFICATION) foi desativada. Para ativá-la acesse as preferências de notificação",
    DOCUMENT_AUTHENTICATED: "validou o documento",
    DOCUMENT_JOIN: "Documento juntado",
    DOE_ALERT_CREATE:
      "Para marcar o documento para publicação é necessário selecionar um dos tipos de documento DOE.",
    DOE_ALERT_MAX_SIZE:
      'Não é possível marcar "Publicar DOE", pois o limite máximo disponível para anexar documentos foi atingido.',
    DOE_ALERT_WRONG_EXTENSION:
      "Para marcar o documento para publicação, o arquivo editável deve estar com a extensão DOCX ou ODT.",
    DOE_CHANGED_PROGRAM_PUBLISH: "DOE Programação de publicação alterada",
    DOE_PROGRAMMED_PUBLISH: "Programação de publicação configurada",
    DOE_PROGRAM_CANCELED: "DOE Programação de publicação cancelada",
    DOE_PUBLISH: "DOE Publicado",
    DOE_REFUSED_PUBLISH: "DOE Publicação Recusada",
    DOE_REGISTER: "Registrar Publicação",
    DOWNLOAD_FINISHED: "Downloads concluídos",
    DOWNLOAD_QUANTITY: "Fazendo download de (QUANTITY) itens",
    DOWNLOAD_QUANTITY_SINGULAR: "Fazendo download de (QUANTITY) item",
    DRAFT_SAVE: "Rascunho salvo",
    DRAG_AND_DROP: "Arraste e solte",
    EDIT_IN_DOCS: 'Editar em "Google Documentos"',
    EMPTY_DISPATCH: "O campo 'Despacho' é obrigatório",
    EMPTY_JUSTIFICATION: "Justificativa é obrigatório",
    EMPTY_TO: "O campo 'Para' é obrigatório",
    EXISTS_UPDATE: "Existem novas atualizações, por favor recarregue a página",
    EXPORTATION_STARTED: "A exportação foi iniciada.",
    FEEDBACK_REFER: "Área do sistema",
    FEEDBACK_TYPES: "Tipo de comentário",
    FILL_OBLIGATORY_FIELDS: "Preencher campos obrigatórios",
    FILE_LIST: "Listagem de arquivos",
    FORWARD_PROCESS: "Processo(s) encaminhado(s) para o setor",
    GAVE_KNOWLEDGE_TO: "deu ciência",
    GIVE_KNOWLEDGE_FAIL: "Erro ao dar ciência",
    GIVE_KNOWLEDGE_FINISHED: "Todos os envios de ciência foram concluídos",
    GIVE_KNOWLEDGE_QUANTITY: "Dando ciência para (QUANTITY) usuários",
    GIVE_KNOWLEDGE_QUANTITY_SINGULAR: "Dando ciência para (QUANTITY) usuário",
    HAS_MIGRATE:
      "Existem processos migrados na sua seleção, que não podem ser devolvidos",
    INFO_HORIZONTAL_LOGO:
      "Para órgãos/entidades vinculadas, o arquivo da logo horizontal anexado deve conter a logo do órgãos/entidades ao qual está subordinado, em conformidade com o Manual de Identidade Visual do Governo do Estado do Ceará.",
    INFO_VERTICAL_LOGO:
      "A logo vertical não é obrigatória para órgãos/entidades vinculadas. Quando não houver uma logo vertical anexada, a logo horizontal será utilizada nos documentos.",
    INITIAL_FILE_SIGNED: "Conter assinatura válida no documento de solicitação",
    INSERT_REASON_ARCHIVE: "Por favor, inserir o motivo do arquivamento",
    INSERT_REASON_DESARCHIVE: "Por favor, inserir o motivo do desarquivamento",
    INSERT_REASON_REFUSE: "Por favor, inserir o motivo da recusa",
    INTERESTED_NOTIFICATION: "Adicionado como interessado",
    JOINT_BY_APPEND: "Juntada por apensação",
    JOINT_BY_DOCUMENT: "Juntada de documentos",
    KNOWLEDGE_GIVEN: "Dado ciência",
    LIMIT_ATTACH_NAME:
      "Nome do arquivo é maior que o limite de <b>LIMIT</b> caracteres",
    LIMIT_COUNT_FILES:
      "Limite de quantidade de documentos atingido! A quantidade máxima por tramitação é de LIMIT documentos.",
    LIMIT_PROCESS_ATTACHMENT: "Tamanho disponível para anexação",
    LIMIT_PROCESS_SIZE:
      "Não é possível anexar novos documentos pois o processo atingiu o tamanho máximo (800MB).",
    LIMIT_PROCESS_SIZE_EXCEEDED:
      "O tamanho máximo de documentos do processo (800MB), foi ultrapassado, exclua documentos para tramitar.",
    LIMIT_NUMBER_DOCUMENTS: "Limite de quantidade de documentos",
    MARKED_TO_DOE: "marcou documento para publicação DOE",
    MARK_ALL_READ: "Marcar tudo como lido",
    MARK_ALL_READ_2: "Marcar todos como lido",
    MARK_READ: "Marcar como lidas",
    MESSAGE: "Mensagens",
    MIGRATE_ERROR: "erro ao migrar",
    MIGRATE_FINISHED: "Todos os processos foram migrados",
    MIGRATE_PENDING: "Aguardando lista de migração",
    MIGRATE_PROCESS: "Migração de processo",
    MIGRATE_QUANTITY: "(QUANTITY) migrações em progresso",
    MIGRATE_QUANTITY_SINGULAR: "(QUANTITY) migração em progresso",
    MODEL_NAME: "Nome do modelo",
    MY_REQUIREMENT_SIGNING: "Recebidas",
    MY_SIGNED: "Respondidas por mim",
    MY_SIGNING_REQUESTS: "Enviadas",
    NEW_ACTIONS: "Clique para ver novas ações",
    NONE: "Nenhum",
    NONE_NOTIFICATION: "Nenhuma notificação",
    NOTIFICATION_RECEIVED: "Notificações recebidas",
    NO_CONTAIN_DECLINED_SIGNATURE: "Não deve conter assinatura recusada",
    NO_DOCUMENTS: "Não há documentos",
    NO_MODELS: "Não há modelos",
    NO_PROGRESS_PUBLISH_REQUEST_SIGNATURE:
      "Para solicitar assinatura, selecione documentos que não estejam com publicação em andamento.",
    NO_PROGRESS_PUBLISH_SIGNATURE_CURRENT_USER:
      "Para assinar, selecione documentos que não estejam assinados por você e/ou com publicação em andamento.",
    NOT_PROCESS_ORIGIN:
      "Não é possível tramitar à origem, pois o processo não está no seu setor.",
    NUP_NOT_GENERATED: "Não gerado",
    OBLIGATORY_SIGNATURE_CHANGED: "Assinatura obrigatória alterada",
    OF_PUBLICATION_ON_DOE: "de publicação no DOE",
    OF_SIGNATURE_TO_DOCUMENT: "de assinaturas para o documento",
    PDF_VIEW_HTML:
      "<p class='has-text-weight-bold'>Visualizar PDF dos documentos</p><p style='text-wrap: wrap;'>Confira a nova forma de visualizar e navegar pelo processo em árvore de documentos agrupados pelo setor responsável pela inclusão.</p>",
    PENDING_SIGNATURE: "assinatura pendente",
    PENDING_SIGNATURES: "assinaturas pendentes",
    PENDING_SIGNATURE_AT_LEAST_ONE:
      "Possuir pelo menos uma assinatura pendente",
    PERMISSIONS_EDIT: "Editar permissões",
    PROCESSED_ORIGIN: "Tramitar à origem",
    PROCESS_APPEND: "Processo apensado",
    PROCESS_APPENDER: "Processo apensador",
    PROCESS_ARCHIVED: "Processo arquivado",
    PROCESS_ARCHIVED_SUCCESS: "Processo(s) arquivado(s) no(a) (CAPACITIES)",
    PROCESS_ASSIGNED: "Processo atribuído",
    PROCESS_ASSIGN_RESPONSIBLE:
      "Processo(s) atribuído(s) para (NAME_AND_ORGAN)",
    PROCESS_CREATED: "Processo criado",
    PROCESS_DISPATCHED: "Processo despachado",
    PROCESS_LIST: "Listagem de processos",
    PROCESS_RETURNED: "Processo devolvido",
    PROCESS_TO_APPEND: "Processo a apensar:",
    PROCESS_UNARCHIVED: "Processo desarquivado",
    PROCESS_UNARCHIVED_SUCCESS:
      "Processo(s) desarquivado(s) no(a) (CAPACITIES)",
    PROCESS_UNFAVORITED: "Processo desfavorito",
    PROCESS_SUBMIT: "Tramitando (QUANTITY) processos",
    PROCESS_SUBMIT_ALERT: "Tramitação em progresso",
    PROCESS_SUBMIT_SINGULAR: "Tramitando ultimo processo",
    PROCESS_SUBMIT_FINISHED: "Tramitação concluída",
    PROCESSES_APPENDERS: "Processos apensados",
    PROGRAMMED_SIGNATURES_IN_DOE: "Assinaturas programadas em documentos DOE",
    PUBLICATION_ON_DOE: "publicação no DOE",
    QA_TAG: "Ambiente de teste",
    RECEIVE_PROCESS_DATA:
      "Receber dados do processo e andamento por Email e notificação no Suite",
    REFUSED_SUBSCRIPTION: "Assinatura recusada",
    REFUSED_SUBSCRIPTION_2: "assinatura",
    REFUSE_SUBSCRIPTION: "Recusar assinatura",
    REMOVE_CAPACITY: "Remover lotação",
    REMOVE_SIGNATURE_CURRENT_USER:
      "Para assinar, selecione documentos que não estejam assinados por você.",
    REQUEST_SIGNATURE_SUCCESS: "Solicitação de assinatura recusada!",
    SCHEDULER_MODAL_TITLE: "Informe o prazo do processo",
    SELECT_FILE: "Anexar documento",
    SELECT_FROM_COMPUTER:
      "clique aqui e selecione os arquivos do seu computador.",
    SELECT_NO_EFFECT_DOCUMENT:
      "Para dar ciência, selecione apenas documentos com efeito.",
    SELECT_REASON_ARCHIVED: "Selecione o motivo do arquivamento",
    SIGNATURE_CANCELED: "Assinatura cancelada",
    SIGNATURE_ERROR: "Erro ao assinar",
    SIGNATURE_FINISHED: "Todas as assinaturas concluídas",
    SIGNATURE_LIST: "Listagem de assinaturas",
    SIGNATURE_QUANTITY: "(QUANTITY) assinaturas em progresso",
    SIGNATURE_QUANTITY_SINGULAR: "(QUANTITY) assinatura em progresso",
    SIGNED: "assinou",
    SIGNED_DOCUMENT: "Documento assinado",
    SIGNED_EXTERNAL: "assinou externamente",
    SIGN_DOCUMENT: "Assinar documento",
    SINCE: "desde",
    THE_PUBLICATION_ON_DOE: "a publicação no DOE",
    TIP_EDITABLES_FILES:
      "Arquivos editáveis são documentos para publicação no DOE ou arquivos editáveis que não irão compor o processo, apenas para consulta.",
    TITLE_INFO_FILE_UPLOAD_EDITABLE: "Extensões de arquivo permitidas:",
    TURNED_NO_EFFECT: "tornou sem efeito",
    REVERT_TURN_NO_EFFECT: "reativou o documento sem efeito",
    TYPE_SELECTION_BATCH:
      'Selecione mais de um documento para alterar o "Tipo de documento" em lote',
    TYPE_TO_SEARCH_DOCUMENT_TYPE: "Digite para pesquisar tipo de documento",
    UNABLE_CREATE_DOCUMENT_SIZE:
      "Não é possível criar documento, pois o limite máximo disponível para anexar documentos foi atingido.",
    UNABLE_TO_ATTACH_DOCUMENT:
      "Não é possível anexar documento, pois o limite máximo disponível para anexar documentos foi atingido.",
    UNABLE_TO_GIVE_KNOWLEDGE:
      "Existem documentos selecionados que não podem ser validados.",
    UNABLE_TO_SIGN:
      "Existem documentos selecionados que não podem ser assinados.",
    UNABLE_TO_UNARCHIVED:
      "Os processos não podem ser desarquivados por usuários de outras lotações.",
    UNABLE_TO_UNARCHIVED_SINGULAR:
      "O processo não pode ser desarquivado por usuários de outras lotações.",
    UNABLE_TO_VIEW_CONTENT:
      "O conteúdo do processo não está disponível no Suite, pois o cadastro e gerenciamento são realizados pelo sistema",
    UNITY_PERMISSIONS: "Permissões de unidade",
    UNMARKED_TO_DOE: "desmarcou documento para publicação DOE",
    UPDATED_CATEGORY: "Categoria atualizada com sucesso!",
    UPDATED_SUBCATEGORY: "Subcategoria 1 atualizada com sucesso!",
    UPDATED_SUBCATEGORY_2: "Subcategoria 2 atualizada com sucesso!",
    UPLOAD_FINISHED: "Uploads concluídos",
    UPLOAD_QUANTITY: "Fazendo upload de (QUANTITY) itens",
    UPLOAD_QUANTITY_SINGULAR: "Fazendo upload de (QUANTITY) item",
    UNAPPEND_JUSTIFICATION: "Digite a motivação da desapensação.",
    USER_INFO:
      "Os dados cadastrais e de contato dos usuários são gerenciados pelos setores de gestão de pessoas ou de terceirização nos respectivos sistemas.",
    VIEW_APPENDED_PROCESS: "Visualizar processo apensador",
    VIEW_MODEL: "Visualizar modelo",
    VIEW_PRINT_VERSION: "Visualizar versão de impressão",
    WAIT_FOR_ALL_FILES_TO_LOAD:
      "Aguarde todos os documentos anexados serem carregados",
    WARNING_ATTACHMENT_PDF:
      'Só documentos em formato PDF são aceitos. Anexe outros formatos em "arquivos editáveis".',
    WARNING_ATTACHMENT_EDITABLE:
      "Existem documentos com formatos não permitidos. Verifique no modal os formatos permitidos e anexe novamente.",
    WARNING_CHANGE_PROGRAMMED_DOE:
      "Tem certeza que deseja alterar a programação?<br/>Existem outras datas programadas para este documento que não serão alteradas.",
    WARNING_DECLINE_DOE:
      "Tem certeza que deseja recusar este documento?<br/>As outras programações deste documento também serão recusadas.",
    WARNING_EXCLUDE_MESSAGE_ADM:
      "Tem certeza que deseja excluir essa mensagem? Ela será excluída para todos os usuários do sistema e não poderá ser recuperada.",
    WARNING_HAS_FUTURE_PUBLISH_DATE:
      "Existem documentos com datas programadas futuras, tem certeza que deseja registrar a publicação destes documentos?",
    WEEKDAYS: "Dias úteis",
    WHAT_ARE_YOU_SEARCHING: "O que você está procurando?",
    WITH_ACESS_CODE: "Código de acesso"
  },
  MESSAGES: {
    ALERT_AUTHENTICATED_FILE:
      "Não é possível validar um documento assinado por você",
    ALERT_CHANGE_SECRECY:
      "O nível de acesso não foi alterado, pois é obrigatória a inclusão de uma referência legal.",
    ALERT_CHANGE_SECRECY_RESPONSIBLE:
      "Não foi possível alterar o Nível de acesso, pois é necessário estar atribuído como responsável do processo.",
    ALERT_CLICK_HERE_LATEST_VERSION_DOCUMENT:
      "Clique aqui para acessar a última versão do documento",
    ALERT_CREATE_INITIAL_FILE:
      "Para criar a solicitação é necessário que os campos 'Para' e 'Assunto' estejam preenchidos",
    ALERT_CREATE_INITIAL_FILE_PROTOCOLER:
      "Para anexar a solicitação é necessário que os campos 'Para', 'Assunto' e 'Interessado' estejam preenchidos.",
    ALERT_CREATE_BOOKMARK_PART:
      "Não é possível salvar, pois é necessário informar o(s) órgão(s)/unidade(s) da aplicabilidade do marcador.",
    ALERT_CREATE_BOOKMARK_CAPACITY:
      "Não é possível salvar, pois é necessário informar o setor/unidade da aplicabilidade do marcador.",
    ALERT_DOCUMENT_SECRECY:
      "Este(s) documento(s) pertence(m) a um processo com <b class='has-text-green-lawn-dark'>nível de acesso Sigiloso</b>. Deseja continuar?",
    ALERT_EXTERNAL_SIGNATURE:
      "Não é possível visualizar este documento, pois você recusou a assinatura ou a solicitação foi cancelada.",
    ALERT_FILES_MAX_SIZE:
      "O tamanho de todos os arquivos não pode ser maior que (fileSize)",
    ALERT_PROCESS_NOTIFICATION_ENALBED:
      "Não é possível desmarcar, pois a opção de receber notificações de processos analisados por você está ativa",
    ALERT_PROCESS_SECRECY:
      "Este(s) processo(s) tem <b class='has-text-green-lawn-dark'>nível de acesso Sigiloso</b>. Deseja continuar?",
    ALERT_PROCESS_SECRECY_MULTIPLES:
      "Um ou mais processos têm <b class='has-text-green-lawn-dark'>nível de acesso Sigiloso</b>. Deseja continuar?",
    ALERT_REMOVE_LEGAL_REFERENCE:
      "A Referência Legal do assunto deve estar presente para esse nível de acesso.",
    ALERT_REQUEST_GIVE_KNOWLEDGE_OVERSIZED_FILE:
      "Não é possível dar ciência nesse documento, pois seu tamanho é maior que 30MB.",
    ALERT_REQUEST_SIGNATURE_DUPLICATED:
      "Não é possível solicitar assinatura externa e interna para o mesmo usuário.",
    ALERT_REQUEST_SIGNATURE_OVERSIZED_FILE:
      "Não é possível solicitar assinaturas nesse documento, pois seu tamanho é maior que 30MB.",
    ALERT_REQUIRED_FIELD: "O campo (field) é obrigatório",
    ALERT_REQUIRED_FIELD_PLURAL: "Os campos (field) são obrigatórios",
    ALERT_SIGN_OVERSIZED_FILE:
      "Não é possível assinar esse documento, pois seu tamanho é maior que 30MB.",
    ALL_ATTACHMENT_NAME: "Todos os anexos precisam de um nome",
    APPENDED_PROCESS_CONFIRM: "O processo NUP (NUP) foi apensado",
    ARE_YOU_SURE_YOU_WANT_CANCEL_DRAFT:
      "Tem certeza que deseja desistir deste processo? Esta ação <strong>excluirá</strong> as informações e os documentos cadastrados na tela.",
    ARE_YOU_SURE_YOU_WANT_CANCEL_DISPATCH_DRAFT:
      "Tem certeza que deseja desistir deste despacho? Esta ação <strong>excluirá</strong> as informações e os documentos cadastrados na tela.",
    ARE_YOU_SURE_YOU_WANT_CANCEL_JOINT_DRAFT:
      "Tem certeza que deseja desistir desta juntada de documentos? Esta ação <strong>excluirá</strong> as informações e os documentos cadastrados na tela.",
    ARE_YOU_SURE_YOU_WANT_DELETE_CAPACITY_AND_DRAFTS:
      "Tem certeza que deseja excluir esta lotação? Essa ação excluirá os rascunhos dos processos associados a essa lotação.",
    ARE_YOU_SURE_YOU_WANT_DELETE_DRAFTS:
      "Tem certeza que deseja excluir o(s) rascunho(s)",
    ARE_YOU_SURE_YOU_WANT_DELETE_MODEL:
      "Tem certeza que deseja excluir os dados desse modelo?",
    ARE_YOU_SURE_YOU_WANT_DELETE_PART_ADDRESS:
      "Tem certeza que deseja excluir os dados desse Órgão/Entidade?",
    ARE_YOU_SURE_YOU_WANT_EXPORT_PROCESSES:
      "Tem certeza que deseja exportar os processos",
    ARE_YOU_SURE_YOU_WANT_PROCESS_ORDER:
      "Tem certeza que deseja tramitar o processo",
    ARE_YOU_SURE_YOU_WANT_SAVE_DRAFT:
      "Tem certeza que deseja salvar este rascunho",
    ARE_YOU_SURE_YOU_WANT_SUBMIT_PROCESS:
      "Tem certeza que deseja tramitar o processo?",
    ARE_YOU_SURE_YOU_WANT_UNFAVORITE_PROCESSES:
      "Tem certeza que deseja desfavoritar os processos",
    ARE_YOU_SURE_YOU_WANT_VALIDATE_FILE:
      "Tem certeza que deseja validar esse documento?",
    ATTACHMENT_NAME: "O anexo precisa de um nome",
    BATCH_SUBSCRIPTION_PROCESSING: "Processando assinatura em lote...",
    BOOKMARK_DELETE:
      "Tem certeza que deseja <span class='has-text-danger has-text-weight-semibold'>excluir este marcador</span>?",
    BOOKMARK_DELETE_BATCH:
      "Tem certeza que deseja <span class='has-text-danger has-text-weight-semibold'>excluir estes marcadores</span>?",
    BOOKMARK_DELETE_SUCCESS: "Marcador excluído com sucesso",
    BOOKMARK_DELETE_SUCCESS_BATCH: "Marcadores excluídos com sucesso",
    BOOKMARK_USED:
      "Não é possível excluir, pois o marcador está sendo utilizado em processo(s)",
    BOOKMARKS_LIMIT_NAME_SIZE: "Nome do marcador tem limite de 20 caracteres",
    BOOKMARKS_SAVED: "Marcador salvo com sucesso!",
    CAPACITY_SUCCESSFULLY_DELETED: "Lotação removida com sucesso!",
    CAPACITY_SUCCESSFULLY_SAVED: "Lotação adicionada com sucesso!",
    CAPACITY_SUCCESSFULLY_UPDATED: "Lotação atualizada com sucesso!",
    CHANGE_UNITY_TO: "Unidade alterada para",
    CONFIRM_RESPONSIBLE_PROCESS:
      "O processo selecionado já possui responsável atribuído, conforme exibido abaixo. Deseja prosseguir com a ação?",
    CONFIRM_RESPONSIBLE_PROCESSES:
      "Existem processos selecionados que já possuem responsáveis atribuídos, conforme listagem abaixo. Deseja prosseguir com a ação?",
    CHANGE_SECRECY_PROCESS:
      "Para alterar o nível de acesso é necessário adicionar pelo menos uma referência legal",
    CREATE_EMPTY_DOCUMENT: "Isso criará um documento vazio. Tem certeza",
    DISABLE_POPUP:
      "Você precisa desabilitar o bloqueador de Pop-ups do seu navegador",
    DISPATCH_FILLED:
      "Esta ação <b class='has-text-green-lawn-dark'>apagará o despacho</b> preenchido. Deseja prosseguir",
    DISPATCH_PROCESS: "O processo foi tramitado!",
    DOCUMENTS_WERE_NOT_SIGNED: "Alguns documentos não foram assinados",
    DOCUMENTS_WERE_SIGNED: "Os documentos foram assinados",
    DOCUMENT_JOIN_FILLED_PLURAL:
      "Essa ação impedirá que os(as) usuários(as) (USERS) dêem seguimento às juntadas de documentos que estão em andamento. Deseja continuar?",
    DOCUMENT_JOIN_FILLED_SINGULAR:
      "Essa ação impedirá que o(a) usuário(a) (USERS) dê seguimento à juntada de documento que está em andamento. Deseja continuar?",
    DOCUMENT_WILL_BE_PUBLISHED:
      "Este documento será enviado para publicação no DOE?",
    DOCUMENT_WILL_BE_PUBLISHED_PROCESS:
      'Ao ativar a opção "Publicar DOE", será criado o PDF nos documentos do processo. Para editar o arquivo, é necessário desativar a opção. Deseja prosseguir?',
    DOCUMENT_WILL_NOT_BE_PUBLISHED:
      'Ao desativar a opção "Publicar DOE", o documento não será mais publicado e o arquivo PDF será mantido nos documentos do processo. Deseja prosseguir?',
    DOCUMENT_WILL_NOT_BE_PUBLISHED_AND_DELETED:
      "Esta ação removerá o PDF do processo e o documento não será mais publicado no DOE. Deseja prosseguir?",
    DOC_SEND_TO_DOE:
      'O documento será marcado definitivamente como "Enviado para DOE". Deseja continuar essa ação?',
    DOC_SEND_TO_DOE_PLURAL:
      'Os documentos serão marcados definitivamente como "Enviado para DOE". Deseja continuar essa ação?',
    DO_YOU_WANT_DELETE_REQUEST:
      "Tem certeza que deseja excluir esse documento?",
    DO_YOU_WANT_DELETE_REQUEST_DOE:
      "Ao excluir este PDF, o documento editável será desmarcado para publicação no DOE. Deseja prosseguir?",
    DO_YOU_WANT_DELETE_REQUEST_DOE_EDITABLE:
      "Esta ação excluirá o documento editável e o PDF gerado. Deseja prosseguir?",
    DO_YOU_WANT_DELETE_REQUEST_PLURAL:
      "Tem certeza que deseja excluir esses documentos?",
    DO_YOU_WANT_SIGNED_DOC:
      "Após o documento de TYPE_DOC ser assinado, não será mais permitido anexar documentos. Para adicionar ou excluir documentos anexados será necessário excluir a assinatura do documento de TYPE_DOC. Deseja prosseguir com essa ação?",
    DRAFT_SUCCESSFULLY_DELETED: "Rascunho deletado com sucesso!",
    DRAFT_SUCCESSFULLY_SAVED: "Rascunho salvado com sucesso!",
    EDIT_SIGNED_DOCUMENT:
      "Tem certeza que deseja editar o documento? Essa ação irá excluir as assinaturas realizadas e pendentes.",
    EMAIL_SEND:
      "Os dados do processo serão enviados para os e-mails dos interessados, quando aplicável.",
    EMPTY_DESCRIPTION_PERMISSION: "Insira a descrição da permissão",
    EMPTY_DOCUMENT: "Documento está vazio",
    EMPTY_FIELD: "Campos vazios, preencha algum campo",
    EMPTY_FILTER: "Preencha todos os filtros",
    EMPTY_FILTER_VALUE:
      "Preencha todos os campos do filtro, antes de adicionar mais",
    EMPTY_NAME: "É Necessário incluir nome do anexo",
    EMPTY_TYPE: "Documento está sem tipo",
    ERROR_DROP_ALL_MANDATORY_SIGNATURE:
      "Não é possível excluir esta assinatura, pois é necessário informar pelo menos uma assinatura obrigatória.",
    ERROR_NO_PERMISSION: "Você não possui permissão para realizar essa ação",
    ERROR_NO_PERMISSION_FORWARD:
      "Apenas usuários com permissão Encaminhar podem utilizar essa funcionalidade",
    FEEDBACK_SUCCESS: "O seu feedback foi enviado com sucesso!",
    GIVE_KNOWLEDGE_COVER_DESCRIPTION: "Dar ciência da capa do processo",
    INFORM_CPF: "Informe um CPF",
    INFORM_PASSWORD: "Informe uma senha",
    INSERT_SUBJECT_ON_PROCESS:
      "Insira um assunto no processo para realizar essa ação.",
    IS_THERE_A_JOIN_DRAFT:
      "Existe um rascunho de <b>juntada de documentos</b> neste processo.",
    LOADING_RECORDS: "Carregando registros...",
    NECESSARY_TOFILL_INTHE_FIELDS: "Necessário preencher o(s) campo(s):",
    NEW_ACTIONS: "para ver as novas ações realizadas no processo",
    NOTIFICATIONS_CONFIG_SAVED: "Preferências de notificações atualizadas",
    NO_ATTACHMENT_TYPE: "Nenhum tipo encontrado",
    NO_CATEGORY_FOUND: "Nenhuma categoria encontrada",
    NO_LEGAL_REFERENCE: "Nenhuma legislação encontrada",
    NO_LEGISLATION_DOC: "Nenhum documento de legislação",
    NO_NUP_FOUND: "Nenhum NUP encontrado",
    NO_ORGAN_ENTITY: "Nenhum órgão/entidade encontrado",
    NO_PROFILE_FOUND: "Nenhum perfil encontrado",
    NO_ORGAN_SECTOR: "Nenhum órgão/setor encontrado",
    NO_RECORDS_FOUND: "Nenhum registro encontrado.",
    NO_RESULT_FOUND: "Nenhum resultado encontrado",
    NO_SECTOR_UNITY_FOUND: "Nenhum setor/unidade encontrado",
    NO_SUBCATEGORY_FOUND: "Nenhuma subcategoria encontrada",
    PERMISSION_SUCCESS: "Permissão salva com sucesso!",
    PROCESSE_ALREADY_ADD: "O processo já foi adicionado!",
    PROCESSED_PROCESS_CONFIRM: "O processo NUP (LINK) foi tramitado",
    PROCESSED_SUCCESS: "Os processos foram tramitados",
    PROCESSES_SUCCESSFULLY_EXPORTED: "Processos exportados com sucesso!",
    PROCESSES_SUCCESSFULLY_UNFAVORITED: "Processos desfavoritados com sucesso!",
    SELECT_AN_REANSON: "Por favor, selecione o motivo da recusa",
    SELECTED_RETROACTIVE_DATE:
      "Você selecionou uma data retroativa para programar a publicação.",
    SIGNING_ATTACH_FILE:
      "Existem documentos não assinados. Por favor, verifique as assinaturas pendentes",
    THE_FILE_SIZE_EXCEEDS_ALLOWED_LIMIT:
      "O tamanho do arquivo excede o limite permitido, que é de",
    TRAMITED_PROCESS: "Seu Processo foi tramitado!",
    TO_VIEW_COVER_DESCRIPTION: "Visualizar capa do processo",
    WARNING_APP_GOOGLE_DOCUMENTS:
      'É necessário ter o aplicativo "Documentos Google" instalado em seu dispositivo.<br/><br/>Deseja ser redirecionado?',
    WARNING_AUTOMATIC_PROCESSING_CANCELLED:
      "A tramitação automática deste processo foi cancelada, pois a(s) assinatura(s) do documento de despacho não pode(m) autorizar o trâmite.",
    WARNING_SUBMIT_PROCESS: "Tramitação em andamento, espere a conclusão!",
    WARNING_AUTO_PROCESS:
      "O processo será tramitado automaticamente quando houver uma <span class='custom-color-green'>assinatura válida no documento de solicitação</span> e <span class='custom-color-green'>não houver assinaturas pendentes ou recusadas</span>. <strong>Deseja continuar essa ação</strong>",
    WARNING_CANCEL_AUTO_PROCESS:
      "Ao desativar essa opção o processo não será tramitado automaticamente. Deseja continuar essa ação",
    WARNING_CHANGE_CAPACITY:
      "Mude para a lotação de abertura do processo/despacho para acessá-lo",
    WARNING_DECLINE_DOE:
      "Esse documento não pode ser recusado pois já existe uma publicação registrada em outra data",
    WARNING_DISPATCH_DOCUMENT_WITH_SIGN_DONE:
      "Não é possível realizar esta ação, pois o despacho está assinado. Para adicionar, editar ou excluir documentos anexados, é necessário remover a assinatura do documento de despacho.",
    WARNING_DOCUMENT_WITH_SIGN_DONE:
      "Não é possível realizar esta ação, pois a solicitação está assinada. Para adicionar, editar ou excluir documentos anexados, é necessário remover a assinatura do documento de solicitação.",
    WARNING_DOE_PROCESS_FILE:
      "Acesse o painel de documentos DOE para realizar esta ação",
    WARNING_INTEGRATION_PROCESS:
      "Não é possível realizar esta ação em processos integrados a outros sistemas",
    WARNING_INTEGRATION_PROCESS_SYSTEM:
      "Não é possível realizar esta ação em processos abertos pelo sistema",
    WARNING_JOIN_DOCUMENT:
      "Atenção, foi realizada uma juntada de documentos. Novos documentos adicionados ao NUP (NUP)",
    WARNING_LEVEL_DIFFERENT_PARENT:
      "O nível de (TYPE) está diferente da categoria superior. Deseja continuar essa ação?",
    WARNING_PUBLISH_DOE:
      "Para registrar a publicação no DOE, é necessário ter marcado o documento como enviado para DOE",
    WARNING_RESPONSIBLE:
      "Existem processos selecionados que já possuem responsáveis atribuídos, conforme listagem abaixo, apenas esses processos não poderão ser devolvidos. Deseja prosseguir com a ação?",
    WARNING_RESPONSIBLE_NOT_IS_YOU:
      "É necessário ser responsável pelo processo",
    WARNING_SELECT_PART_CAPACITY: "Selecione um órgão/unidade",
    WITHDRAWALS_1: "O interessado desistiu da solicitação.",
    WITHDRAWALS_2: "para arquivar o processo.",
    WITHOUT_RESPKI:
      "A extensão Web PKI é necessária para assinar com certificado digital no Suite. Deseja prosseguir para a instalação?",
    CANCEL_ALERT: {
      NOT_SAVED: "O documento não será salvo e não será possível recuperá-lo.",
      QUESTION: "Tem certeza que deseja sair da tela?",
      SAVED: "As alterações realizadas permanecerão salvas no documento."
    },
    GIVE_BACK_ALERT: {
      BATCH: "Os processos foram devolvidos para o setor",
      UNIQUE: "O processo foi devolvido para o setor"
    },
    VALIDATE: {
      CNPJ: "CNPJ inválido",
      CPF: "CPF inválido",
      MAIL: "Email inválido",
      MAX: "O campo suporta apenas {length} caracteres",
      MIN: "O campo suporta no mínimo {length} caracteres",
      REQUIRED: "Campo obrigatório",
      URL: "Informe uma URL válida",
      XSS: "Existe dados inválidos (XSS)"
    }
  },
  GA_INFO: {
    INFO:
      "Este site utiliza a ferramenta Google Analytics para coleta de dados estatísticos de acesso.",
    ABOUT: "e saiba mais sobre o uso de cookies do Google Analytics em sites."
  },
  ARIA_LABEL: {
    ACCESS_LEVEL: "Nível de acesso",
    ACCESS_RECOVER_PASSWORD: "Acesse a página para recuperação de senha",
    ACTION_BUTTON: "Botão de ação",
    ARCHIVE: "Botão para arquivar o processo",
    AUTHENTICATE_DOCUMENT: "Botão para autenticar documento",
    AUTHORIZE_DOE: "Botão para autorizar DOE",
    BATCH_CANCEL_SIGNATURE:
      "Botão para cancelar requisição de assinatura em lote",
    BATCH_CHANGE_SCHEDULE_DOE:
      "Botão para alterar programação DOE dos documentos selecionados",
    BATCH_REFUSE_DOE:
      "Botão para recusar a publicação dos documentos selecionados",
    BATCH_REFUSE_SIGN: "Botão para recusar assinatura em lote",
    BATCH_REGISTER_DOE: "Botão para registra DOE dos documentos selecionados",
    BATCH_SCHEDULE_DOE:
      "Botão para realizar a programação da publicação dos documentos selecionados",
    BATCH_SEND_DOE: "Botão para enviar os documentos selecionados para DOE",
    BATCH_SIGN: "Botão para assinar documentos em lote",
    CHANGE_RESPONSIBLE: "Botão para alterar responsável do processo",
    CHANGE_SCHEDULE_DOE: "Botão para alterar programação DOE",
    DELETE_FIELD: "Botão para excluir o item do campo para",
    DELETE_FILTER: "Botão para excluir o filtro:",
    DELETE_NUP: "Botão para excluir o NUP de referência",
    DELETE_TAG: "Botão para excluir o tag",
    DISPATCH_PRIMARY: "Botão para criar documento primário do despacho",
    DISPATCH_PROCESS: "Botão para tramitar despacho",
    DOCS_DOWNLOAD:
      "Botão para fazer o download do PDF dos documentos selecionados",
    DOCS_GIVE_KNOWLEDGE: "Botão para dar ciência dos documentos selecionados",
    DOCS_REQUEST_SIGNATURE:
      "Botão para solicitar assinatura para os documentos selecionados",
    DOE_AUTHORIZE_BUTTON:
      "Botão para autorizar DOE para os documentos selecionados",
    DOCS_SIGN: "Botão para fazer assinatura dos documentos selecionados",
    VIEW_DIGITAL: "Botão para visualizar arquivo digital",
    DOWNLOAD_PRINT_VERSION:
      "Botão para baixar versão de impressão do documento",
    FAVORITE_BUTTON: "Botão para favoritar",
    MODAL_GIVE_KNOWLEDGE: "Botão para abrir modal de dar ciência",
    MODAL_REFUSE_SIGN: "Botão para abrir modal de recusar assinatura",
    MODAL_REQUEST_SIGNATURE:
      "Botão para abrir modal de solicitação de assinatura",
    MODAL_SIGN_DOCUMENT: "Botão para abrir modal de assinar documento",
    MORE_ACTIONS: "Mais ações",
    PRIORITY_LEVEL: "Nível de prioridade",
    PROCESSING: "Botão para tramitar o processo para a origem",
    REFUSE_DOE: "Botão para recusar publicação DOE",
    REGISTER_DOE: "Botão para registrar DOE",
    SCHEDULE_DOE: "Botão para programar publicação DOE",
    SEND_DOE: "Botão para enviar para DOE",
    SHARED_DOCUMENTS: "Botão para visualizar os documentos compartilhados",
    TO_LINK: "Navegar para o link",
    VIEW_DOCUMENT: "Botão para visualizar o PDF do processo",
    VIEW_OCCURRENCY: "Visualizar Folha de ocorrências do processo"
  },
  ASSIGN_STATE: {
    PENDING: "aguardando",
    REFUSED: "recusou",
    SIGNED: "assinou"
  },
  ASSIGN_STATE_MANDATORY: {
    assigned: " - assinado",
    refused: " - recusado",
    pending: " - pendente"
  }
});

export const App = Object.freeze({
  AdminOverviewScreen: {
    ADDRESS_LOGOS: "Endereços e logos",
    SUBJECTS: "Assuntos"
  },

  BookmarksScreen: {
    TEXTS: {
      ARE_YOU_SURE_YOU_WANT_DELETE_BOOKMARK:
        "<span class='has-text-weight-medium'>Tem certeza que deseja <span class='has-text-weight-semibold has-text-danger'>excluir este marcador</span>?<br>Esta ação irá <span class='has-text-weight-semibold'>remover o marcador de todos os processos que o contêm</span>.</span>",
      WANT_DELETE_BOOKMARK_USED:
        "O marcador (bookmark_name) será modificado nos processos em que está sendo utilizado. Deseja prosseguir com a edição?",
      WANT_INACTIVE_BOOKMARK_USED:
        "Ao inativar o marcador (bookmark_name), não será possível adicioná-lo em outros processos.  Deseja prosseguir com a inativação?",
      WANT_INACTIVE_WITH_PROCESS_BOOKMARK_USED:
        "O marcador (bookmark_name) será mantido nos processos em que está sendo utilizado, porém não será possível adicioná-lo em outros processos. Deseja prosseguir com a inativação?"
    }
  },

  Breadcrumb: {
    APP_ADMIN_LINK: "/app/admin",
    APP_LINK: "/app",
    APP_PROCESS_PAINEL_LINK: "/app/processos",
    PERMISSIONS_LINK: "/app/admin/permissao",
    DASHBOARD: "Painel",
    START: "Início",
    START_AREA: "Área Inicial"
  },

  CancelInscription: {
    TITLE: "Você cancelou o recebimento desta notificação",
    SUBTITLE:
      "As notificações do tipo “(NOTIFICATION_NAME)” não serão mais enviadas para o seu e-mail.",
    DESCRIPTION_1:
      "O Suite respeita a sua privacidade, é contra spam e quer enviar e-mails que façam sentido para você.",
    DESCRIPTION_2:
      'Por isso, caso deseje cancelar outros tipos de e-mail, acesse sua área de usuário e desative o recebimento na aba "Preferências de Notificações".'
  },

  Channel: {
    DESCRIPTION: "Você pode entrar em contato nos seguintes canais",
    EMAIL_ATTENDANCE: "E-mail atendimento",
    HELP_CENTER: "Central de ajuda",
    TITLE: "Canais de Atendimento",
    WHATSAPP_ATTENDANCE: "Whatsapp atendimento"
  },

  CreateBookmarkScreen: {
    APPLICABILITY: "Aplicabilidade",
    CREATE_BOOKMARK: "Criar marcador",
    EDIT_BOOKMARK: "Editar marcador",
    MESSAGES: {
      NAME_EMPTY: "Digite o nome do marcador",
      EMPTY_TITLE: "Título vazio",
      INVALID_COLOR: "Cor inválida",
      BOOKMARK_EDITED: "Marcador editado com sucesso"
    },
    PLACEHOLDERS: {
      INSERT_BOOKMARK_NAME: "Insira nome do marcador"
    },
    SELECT_TEXT_COLOR:
      "Selecione a cor do texto do marcador com cuidado, pois a legibilidade pode ser afetada pela cor escolhida para o marcador.",
    TEXT_COLOR: "Cor do texto do marcador",
    TEXTS: {
      CHOOSE_COLOR: "Escolha qualquer cor.",
      OR_CHOOSE_COLOR_BELOW:
        "Ou você pode escolher uma das cores sugeridas abaixo."
    },
    TITLE: "Título"
  },

  DOEPanelScreen: {
    AUTHORIZE: "Autorizados",
    PROGRAMMED: "Programados",
    PUBLICATED: "Publicados",
    REFUSED: "Recusados"
  },

  DOE_EXPORT: {
    NAME_FILE: "Processando lote de exportação DOE",
    NAME_FILE_SINGLE: "Processando exportação DOE"
  },

  DOE_STATUS: {
    AUTHORIZED: "DOE Autorizado",
    PARTIALLY_PUBLISHED: "Parcialmente publicado",
    PROGRAMMED: "DOE programado",
    PUBLISHED: "DOE publicado",
    REFUSED: "DOE recusado",
    TO_PUBLISH: "Publicar DOE",
    UNKNOWN: "Desconhecido"
  },

  DashboardScreen: {
    AWAITING_ANALYSIS: "Processos sem responsáveis",
    COLUMN_CATEGORIA_PRODUTIVITY: "Data de recebimento/tramitacao",
    DOCUMENTS_TO_SIGN: "Documentos para assinar",
    DUE_DATE_PROCESSES: "Processos com prazo",
    HIDDEN_PRODUCTIVITY: "Voltar para Painel de Rotina",
    MY_PRODUCTIVITY: "Produtividade",
    PANEL_VISION_TYPE: "Tipo de visão do painel",
    PROCESSESS_DUE_DATE: "Processos a vencer",
    PROCESS_ANALISIS: "Processos em análise",
    PROCESS_ANALISIS_TIME: "Média de processos abertos e analisados por dia",
    PROCESS_ANALISIS_TIME_AVERAGE: "Tempo médio de análise por processo",
    PROCESS_FOR_ANALISIS: "Processos para análise",
    PROCESS_OPENING: "Processos abertos",
    PROCESS_RECEIVED_BY_CAPACITY: "Processos recebidos por órgão/unidade",
    PROCESS_RECEIVED_BY_SUBJECT: "Processos recebidos por assunto",
    PROCESS_TRAMITED_DISPATCH: "Processos analisados",
    RECEIVED_DESPATCH: "(Abertos ou Recebidos / tramitados)",
    RECEIVED_DESPATCH_PRODUCTIVITY: "Produtividade",
    SECTOR_AND_SUBORDINATES: "Setor e subordinadas",
    SECTOR_PRODUCTIVITY: "Produtividade do setor",
    SHOW_PRODUCTIVITY: "Ver Painel de Produtividade",
    SIGNATURE_PENDING: "Assinaturas pendentes por tempo",
    URGENT_PROCESSED: "Processos urgentes",
    WELCOME: "Seja bem-vindo (a)",
    WELCOME_SUBTITLE:
      "Utilize o painel para uma visão rápida dos processos, solicitações e informações.",
    WELCOME_SUBTITLE_VERSION:
      "O sistema foi atualizado, dia (DATA), com uma nova versão (VERSION)",
    WELCOME_SUBTITLE_VERSION_END: "e veja as melhorias"
  },

  MergeProcess: {
    NUP_NOT_FOUND:
      "Não é possível apensar um processo no qual não está como responsável."
  },

  EDOWebEditor: {
    ADD_ROW: "Adicionar uma linha",
    ALIGN_CENTER: "Alinhar ao centro",
    ALIGN_LEFT: "Alinhar a esquerda",
    ALIGN_RIGHT: "Alinhar a direita",
    BOLD: "Negrito",
    BULLETED_LIST: "Lista com marcadores",
    CLEAN: "LIMPAR",
    COLUMN_NAME: "Nome da coluna",
    TYPE_RESPONSE_OPTION: "Digite uma opção de resposta",
    DROPDOWN_LIST: "Lista suspensa",
    DROP_MODEL:
      "Essa ação irá alterar o conteúdo do modelo que está sendo editado. deseja continuar",
    FAIL_INPUT:
      "Nome do campo inválido. É permitido utilizar apenas o caractere underline ( _ ) para separar palavras",
    FAIL_INPUT_CREATE: "Nome já utilizado para outro campo",
    FIELDS: "Campos",
    FIELDS_CREATED: "Campos criados",
    FIELDS_EMPTY: "Necessário pelo menos um campo simples",
    FINE: "Fina",
    ITALIC: "Itálico",
    JUSTIFY_CONTENT: "Justificar conteúdo",
    LONG_TEXT: "Texto Longo",
    MANDATORY: "Preenchimento obrigatório",
    MARGIN: "Margens",
    MEDIUM: "Medio",
    NORMAL: "Normal",
    NUMBERED_LIST: "Lista numerada",
    OPENED_FIELD: "Campo aberto",
    ONLY_DATES: "Apenas datas (dd/mm/aaaa)",
    ONLY_NUMBER: "Apenas números",
    OPTION_LABEL: "Opções de respostas",
    PAGE_BREAK: "Quebra de página",
    PLACEHOLDER_HELP: "Digite um texto de ajuda",
    PLACEHOLDER_NAME: "Digite no formato nomdedocampo_nomemodelo",
    REDO: "Refazer",
    SELECT_FIELD: "Selecione um campo",
    SELECT_OPTIONS: "Selecione pelo menos duas opções",
    SHORT_TEXT: "Texto Curto",
    SMALL: "Pequena",
    STRIKE_THROUGH: "Riscado",
    SUSPENDED_LIST: "Lista suspensa",
    TABLE: "Tabela",
    TABLE_FIELD: "Tabela",
    TITLE: "Titulo",
    UNDERLINE: "Sublinhado",
    UNDO: "Desfazer"
  },

  ExternalAssign: {
    DIGITE_CGC_ASSIGN: "Digite o CPF/CNPJ do assinante",
    DIGITE_MAIL_ASSIGN: "Digite o email do assinante",
    DIGITE_NAME_ASSIGN: "Digite o nome do assinante"
  },

  ManageUnity: {
    UNITY_CONFIG: "Configurar unidades",
    NAME_FILE: "unidade.xls",
    SUITE_LEVEL: "Nível Suite",
    EMPTY_LEVEL: "Não se aplica",
    REMOVE_FILTER: "Remova o filtro de situação para utilizar"
  },

  ManageUnityFilter: {
    CONFIGURATION: {
      CORE_PROTOCOL: "Protocolo central",
      EXTERNAL_RECEPTOR: "Receptora externa",
      EXTERNAL_TRAMIT: "Tramitadora externa",
      INTERNAL_RECEPTOR: "Receptora interna",
      INTERNAL_TRAMIT: "Tramitadora interna"
    },
    STATUS: {
      ACTIVE: "Ativa",
      INACTIVE: "Inativa"
    }
  },

  MenuAdm: {
    ADDRESS_LOGOS: "Endereços/logos",
    MIGRATION_PROCESS: "Migração de processos",
    REPORTS: "Relatórios",
    MESSAGES_AREA: "Mensagens"
  },

  MenuMain: {
    DOCUMENTS_DOE: "Documentos DOE",
    HELP: "Ajuda",
    HOME: "Painel",
    OPEN_PROCESS: "Abrir Processo",
    PROCESSES: "Processos",
    SIGNATURES: "Assinaturas"
  },

  MessagesAreaScreen: {
    MESSAGE: "Mensagem",
    MESSAGES: "Mensagens",
    MESSAGE_TITLE: "Título da mensagem",
    NEW_MESSAGE: "Nova mensagem",
    NONE_MESSAGE: "Nenhuma mensagem",
    PLACEHOLDER: {
      TYPE_MESSAGE_TITLE: "Digite o título da mensagem",
      TYPE_MESSAGE: "Escreva sua mensagem"
    },
    SEND_MESSAGE: "Enviar mensagem",
    SEND_MESSAGES: "Enviar mensagens",
    SENT_BY: "Enviado por",
    VIEW_MESSAGE: "Ver mensagem"
  },

  MigrationProcess: {
    CANCEL_MIGRATION: "Cancelar migração",
    DETAIL_REASON_MIGRATION_PROCESS:
      "Detalhe o motivo para a migração dos processos",
    DOWNLOAD_PDF_LABEL: "Download do PDF de migrações",
    MESSAGES: {
      MIGRATE_FROM:
        "A origem da migração do processo pode ser uma ou mais unidades ativas ou inativas que possuem processos na aba No Setor e/ou Arquivados que precisam ser migrados para uma unidade de destino.",
      TO:
        "O destino da migração deve ser uma unidade ativa de destino da migração dos processos que serão migrados.",
      WARNING: "Tem certeza que deseja cancelar este agendamento de migração?",
      CANCEL_SUCCESS: "Agendamento cancelado com sucesso."
    },
    MIGRATED_PROCESSES: "Processos migrados",
    MIGRATE_FROM: "Migrar de",
    MIGRATE_TABS_PROCESS: "Migrar processos das abas",
    MIGRATION_DATA: "Dados da migração",
    MIGRATION_DATE: "Data da migração",
    MIGRATION_FROM: "Migração de",
    MIGRATION_PROCESS: "Migrar processos",
    MIGRATION_SCHEDULED_TO: "Migração agendada para:",
    MIGRATION_TABS: "Migrar abas",
    PROCESS_DATA: "Dados dos processos",
    SCHEDULE_MIGRATION_TO: "Agendar migração para:",
    SCHEDULED_MIGRATION: "Migração agendada",
    SCHEDULED_TO: "Agendado para",
    SEARCH_ORGAN_UNITY_ORIGIN: "Digite para pesquisar Órgão/Unidade de origem",
    SEARCH_ORGAN_UNITY_TARGET: "Digite para pesquisar Órgão/Unidade de destino",
    WARNING_MIGRATION_MESSAGE:
      "Tem certeza que deseja realizar a migração? Os processos que estão atribuídos terão os responsáveis removidos e ficarão aguardando análise na nova unidade.",
    WARNING_SCHEDULED_MIGRATION_MESSAGE:
      "Tem certeza que <span class='has-text-green-lawn'>deseja realizar o agendamento da migração?</span> Durante a migração os processos que estão atribuídos terão os responsáveis removidos e ficarão aguardando análise na nova unidade."
  },

  ModalArchive: {
    IN_PERSON: {
      CHECKBOX: "Confirmo que este processo será arquivado fisicamente.",
      WARNING: "É necessário marcar o checkbox de confirmação."
    },
    REASONS: {
      DEFERRED_PROCESS: "Processo deferido",
      PROCESS_DISMISSED: "Processo indeferido",
      TERMINATION_MOTIVATED: "Decisão motivada por autoridade competente",
      WITHDRAWAL: "Desistência ou renúncia do interessado"
    },
    PORTAL: {
      CHECKBOX:
        "Estou ciente que as informações e documentos incluídos durante o arquivamento do processo serão disponibilizados para o solicitante do serviço no Ceará Digital e confirmo que a LGPD e a LAI foram previamente observadas.",
      WARNING:
        "É necessário marcar a opção de declaração de ciência e concordância com a LGPD/LAI."
    }
  },

  ModalDeclinePublication: {
    EMPTY_FIELD: "Preencha todos os campos para prosseguir",
    REASONS: {
      ERROR_IN_CONTENT: "Erro no conteúdo",
      INCONSISTENCY: "Inconsistência de Assinaturas",
      REQUEST_CANCELLATION: "Cancelamento da Solicitação"
    }
  },

  ModalDeclineRequest: {
    DESCRIPTION_REASON_REFUSED: "Descrição do motivo da recusa",
    REASONS: {
      FIX_CONTENT: "Corrigir conteúdo",
      INCORRECT_REQUEST: "Solicitação indevida",
      OTHER: "Outros"
    },
    REASON_REFUSED: "Motivo da recusa"
  },

  ModalDocMandatorySignature: {
    SUBTITLE:
      "Informe as assinaturas que serão solicitadas posteriormente e que são necessárias para a publicação do documento no Diário Oficial do Estado (DOE)."
  },

  ModalEditorApplicability: {
    APPLICABLE_TO_EVERY_CAPACITY: "Aplicável a todos os setores",
    APPLICABLE_TO_EVERY_PART: "Aplicável a todos os órgãos",
    APPLICABLE_TO_EVERY_SECTOR:
      "Aplicável ao seu setor e aos seus setores subordinados (se houver)",
    CAPACITY_PLACEHOLDER: "Pesquisar Setor(es)/Unidade(s)",
    PART_PLACEHOLDER: "Pesquisar Órgão/Entidade",
    SECTOR: "Setor(es)",
    SECTOR_PLACEHOLDER: "Pesquisar Setor",
    TITLE: "Configurações de Aplicabilidade"
  },

  ModalElectronicSignature: {
    BUTTON: "ASSINAR",
    FIELD_EMPTY: "Digite o código de verificação",
    INSERT_CODE: "Insira o código",
    MESSAGE_TO_MARK_CAPACITY: "Selecione uma lotação para assinar.",
    RESEND_CODE: "Reenviar código",
    SEND_CODE: "O código de verificação foi enviado por (token_type).",
    TEXT_INFO:
      "Insira o código de verificação que foi enviado por (token_type).",
    TITLE: "Fator de autenticação",
    TOKEN_WRONG: "Código inválido",
    RECEIVE_TOKEN_BY: "Receber código de assinatura por:"
  },

  ModalInterested: {
    CPF_CNPJ_INTERESTED: "Digite o CPF/CNPJ do interessado",
    MAIL_INTERESTED: "Digite o email do interessado",
    NAME_INTERESTED: "Digite o nome do interessado"
  },

  ModalNoEffect: {
    REASONS: {
      DUPLICATED_DOCUMENT: "Duplicidade de documento",
      MISTAKEN_INCLUSION: "Inclusão equivocada",
      OTHER: "Outros motivos",
      OUTDATED_VERSION: "Versão desatualizada",
      PROCESS_ERRORS: "Erros nos dados das partes do processo",
      TEXT_ERRORS: "Falhas, erros ou omissões no texto"
    },
    TEXT_PLACEHOLDER:
      "Detalhe o motivo para tornar o documento sem efeito. Campo obrigatório.",
    TITLE: "Tornar documento sem efeito"
  },

  ModalRevertNoEffect: {
    BUTTON_LABEL: "Devolver efeito",
    BUTTON_TOOLTIP: `Reativar um documento anteriormente tornado “sem efeito”,
                    mantendo as informações originais, mediante justificativa.`,
    TITLE: "Reativar documento",
    REASONS: {
      COURT_DECISION: "Decisão judicial",
      SUPERIOR_DECISION: "Deliberação superior em grau de recurso",
      PUBLIC_INTEREST: "Razões de interesse público motivada em reanálise",
      FORMAL_MISTAKE: "Erro formal/material"
    },
    DESCRIPITION_PLACEHOLDER: "Descreva o motivo",
    CONFIRMATION_MESSAGE: `Ao realizar esta ação, a tarja 'Sem Efeito' será removida e a validade do documento será restabelecida. Deseja prosseguir?`
  },

  ModalNotification: {
    TEXT: {
      PART_1: "<strong>Exclusão de notificações antigas</strong>",
      PART_2:
        'A partir de (DATE), <strong>as notificações do Suite (sininho) serão permanentemente excluídas</strong> conforme a data informada na coluna "Expira em" na tela "Notificações recebidas".',
      PART_3:
        "Nessa data, também serão excluídas todas as notificações antigas, ou seja, recebidas há mais de 7 meses.",
      PART_4:
        "Para mais esclarecimentos entre em contato com o <a href='https://api.whatsapp.com/send/?phone=558531080123&text&type=phone_number&app_absent=0' target='_blank' rel='search external' class='is-link is-underlined'>atendimento do Suite</a>."
    }
  },

  ModalPartnership: {
    DEVELOPED_BY: "Desenvolvido e mantido por",
    MAIN_TECHNOLOGIES: "Principais tecnologias utilizadas",
    VERSION: "Versão"
  },

  ModalSelectUser: {
    LGPD:
      "Confirmo que a LGPD/LAI foi observada antes de dar ciência a esses usuários.",
    VALIDATE_LGPD: "É necessário confirmar a LGPD/LAI"
  },

  ModalWarningDOE: {
    DESCRIPTION:
      "Não é possível extrair os seguintes documentos pois possuem assinaturas pendentes ou recusadas, para prosseguir com a ação exclua a solicitação ou aguarde a assinatura",
    TITLE: "Não foi possível exportar DOE"
  },

  ModelEditorScreen: {
    MESSAGES: {
      CHANGE_TYPE:
        "Ao alterar o tipo de documento do modelo, o conteúdo será substituído por um novo em branco. <br /><strong>Deseja mudar o tipo de documento do modelo?</strong>"
    }
  },

  ModelsScreen: {
    DOCUMENT_MODELS: "Modelos de documentos",
    DOCUMENT_MODEL_CREATION: "Criar novo modelo de documento",
    DOCUMENT_MODEL_EDITION: "Editar modelo de documento",
    MESSAGES: {
      EMPTY_CAPACITY:
        "Não é possível salvar, pois é necessário informar o setor da aplicabilidade do modelo",
      EMPTY_CONFIG: "Documento não configurado ou incompleto"
    },
    MODEL: "Novo modelo",
    PLACEHOLDER: {
      SEARCH_BY: "Pesquise por nome"
    },
    SELECT_A_TYPE: "Selecione o tipo",
    SELECT_A_DOCUMENT_TYPE: "Selecione o tipo do documento"
  },

  NotificationsConfigScreen: {
    ACTIVATED: "Ativado",
    BY_EMAIL: "Por Email",
    BY_SMS: "Por SMS",
    DEACTIVATED: "Desativado",
    DISABLE_ALL: "Desativar todas",
    ENABLE_ALL: "Ativar todas",
    NONE_NOTIFICATION_NON_READED: "Nenhuma notificação não lida",
    NON_READED: "Não lidas",
    NOT_APPLY: "Não se aplica",
    ON_SYSTEM: "No Sistema",
    PREFERENCE_NOTIFY: "Preferências de notificações",
    TEXTS: {
      NOT_POSSIBLE_DISABLE_BY_EMAIL:
        "Não é possível desabilitar essa notificação por email",
      NOT_POSSIBLE_DISABLE_BY_SMS:
        "Não é possível desabilitar essa notificação por SMS",
      NOT_POSSIBLE_DISABLE_BY_SYSTEM:
        "Não é possível desabilitar essa notificação no sistema",
      SPECIFY_NOTIFICATIONS:
        "Você pode especificar as notificações que deseja receber."
    },
    WARNING_DELETION:
      'A partir (DATE), <strong class="has-text-blue-oil">as notificações do Suite (sininho) serão excluídas permanentemente na data informada na coluna "Expira em"</strong>. Para mais esclarecimentos entre em contato com o Atendimento do Suite.',
    WARNING_TOOLTIP:
      "Essa é a data limite para a visualização da notificação no Suite, pois as notificações são excluídas automaticamente após um período.",
    VIEW_ALL_NOTIFICATIONS: "Ver todas as notificações"
  },

  OfficialModelsScreen: {
    DOCUMENT_MODELS: "Modelos de documentos oficiais",
    DOCUMENT_MODEL_CREATION: "Criar novo modelo de documento oficial",
    DOCUMENT_MODEL_EDITION: "Editar modelo de documento oficial",
    MODEL_NAME: "Nome do modelo",
    MODEL_SMALL_NAME: "Nome reduzido do modelo",
    MODEL_OBLIGATORY_USE: "Modelo de uso obrigatório",
    NEW_MODEL: "Novo modelo",
    PLACEHOLDER: {
      SEARCH_BY: "Pesquise por nome"
    },
    SELECT_A_TYPE: "Selecione o tipo",
    VIEW_DOE: "Visualizar DOE"
  },

  PUBLISH_DOE_FILTER: {
    ABLE_TO_PUBLISH: {
      name: "Apto a publicar DOE",
      value: "ABLE_TO_PUBLISH"
    },
    DOE_AUTHORIZED: {
      name: "DOE Autorizado",
      value: "DOE_AUTHORIZED"
    },
    DOE_PROGRAMMED: {
      name: "DOE Programado",
      value: "DOE_PROGRAMMED"
    },
    DOE_PUBLISHED: {
      name: "DOE Publicado",
      value: "DOE_PUBLISHED"
    },
    DOE_REFUSED: {
      name: "DOE Recusado",
      value: "DOE_REFUSED"
    },
    MARKED_TO_PUBLISH: {
      name: "Marcado para publicar DOE",
      value: "MARKED_TO_PUBLISH"
    }
  },

  PainelSearch: {
    FIX_FILTERS: "Manter filtros fixados na tela",
    HAS_FIX_FILTER:
      "Existem filtros fixados nesta listagem. Remova os filtros para ver a listagem completa."
  },

  PartAddressScreen: {
    APPLICABLE_TO_UNITY: "Aplicável a unidades subordinadas",
    ATTACH_FILE: "Anexar arquivo",
    ATTACH_HORIZONTAL_LOGO: "Logo oficial horizontal",
    ATTACH_VERTICAL_LOGO: "Logo oficial vertical",
    CHANGE_IMAGE: "Selecionar nova imagem",
    EDIT_FORM: "Editar Cadastro",
    HORIZONTAL_LOGO: "logo horizontal",
    LINKED: "Vinculada",
    LOGO: "Logo",
    LOGO_TYPE: {
      HORIZONTAL: "HORIZONTAL",
      VERTICAL: "VERTICAL"
    },
    MESSAGES: {
      ERROR_ON_FIELDS: "Erro no(s) campo(s)",
      EXCEEDED_SIZE: "Tamanho excedido",
      FILE_BROKEN: "Arquivo inválido ou corrompido",
      FILE_CANT_ATTACHED: "O arquivo não pôde ser anexado",
      FILE_FORMAT_SIZE: "Arquivo no formato PNG com tamanho máximo de 10MB.",
      FILE_SIZE_OVERFLOW:
        "O arquivo <b>(FILE_NAME)</b> possui <b>(FILE_SIZE)</b>",
      FILE_WRONG_FORMAT: "O arquivo <b>(FILE_NAME)</b> não é permitido.",
      INVALID_CEP: "CEP inválido",
      INVALID_EMAIL: "E-mail inválido",
      INVALID_FORMAT: "Formato inválido",
      INVALID_NUMBER: "Número inválido",
      INVALID_ORGAN_ENTITY: "Órgão/Entidade inválido",
      INVALID_PHONE: "Telefone(s) inválido(s)",
      INVALID_SITE: "Site inválido",
      MARK:
        'Ao marcar a opção "vinculada" os arquivos de imagem de logo cadastrados serão excluídos e será necessário cadastra-los novamente. Deseja prosseguir com a ação?',
      ONLY_ONE_SOLICITATION: "Só pode ser adicionado uma Solicitação",
      PHONE_LIMIT: "A quantidade de números de telefone chegou ao limite",
      REQUIRED_LOGO: "O arquivo de (LOGO_NAME) é obrigatório",
      TYPE_NECESSARY:
        "Necessário informar documentos aplicáveis aos logotipos.",
      UNMARK:
        'Ao desmarcar a opção "vinculada" os arquivos de imagem de logo cadastrados serão excluídos e será necessário cadastra-los novamente. Deseja prosseguir com a ação?'
    },
    NEW_FORM: "Novo Cadastro",
    PLACEHOLDER: {
      CEP: "60000-000",
      EMAIL: "Insira o e-mail (exemplo@orgao.ce.gov.br)",
      ORGAN_ENTITY: "Digite para pesquisar um órgão/entidade",
      ORGAN_UNITY: "Selecione a unidade",
      SITE: "Insira a URL do site",
      TELEPHONE: "(85)8888-8888"
    }
  },

  PartGeneralInfo: {
    PLACEHOLDER: {
      SEARCH_BY_PART: "Digite para pesquisar por órgão"
    }
  },

  PendingDocumentsScreen: {
    ADD_PENDING_DOCUMENT: "Adicionar outro pendência de documento",
    COMPLEMENTARY_DOCUMENT: "Documentação complementar",
    EMPTY_PENDING_OBSERVATION: "Digite uma observação",
    PENDING_DOCUMENT: "Documento Pendente",
    PENDING_DOCUMENTS: "Documentos pendentes",
    REGISTERED_PENDENCIES: "Pendências registradas",
    SELECT_DOCUMENT: "Selecione o documento",
    SELECT_PENDING_REASON: "Selecione o motivo da pendência"
  },

  ProcessDetailsScreen: {
    BASIC_DATA: "Dados básicos",
    CREATE_DISPATCH: "Criar despacho",
    ORDERS: "Despacho",
    STATE_ON_DATE: "Situação em"
  },

  ProcessOpeningScreen: {
    CREATE_BOOKMARK: "Criar marcador",
    EDIT_BOOKMARK: "Editar marcador",
    MANAGE_BOOKMARKS: "Gerenciar meus marcadores",
    MANAGE_BOOKMARKS_CAPACITY: "Gerenciar marcadores de unidade",
    MANAGE_BOOKMARKS_PART: "Gerenciar marcadores setoriais",
    MANAGE_BOOKMARKS_ADM: "Gerenciar marcadores corporativos",
    PROCESS_DATA: "Dados do Processo",
    PROCESS_REFERENCE: "NUP de Referência",
    PROTOCOL_REFERENCE: "N° de processo externo",
    SELECT_ACCESS_LEVEL:
      "Para selecionar um Nível de acesso, é necessário que o campo 'Assunto' esteja preenchido.",
    SELECT_BOOKMARK_COLOR: "Selecione a cor",
    SELECT_BOOKMARK_TEXT_COLOR: "Selecione a cor do texto do marcador",
    SET_BOOKMARK: "Atribuir marcador",
    SEE_BOOKMARK: "Pré visualização do marcador",
    SOLICITATION: "Solicitação",
    SOLICITATION_CREATED: "Solicitação criada",
    WARNING_IN_PERSON_SUBJECT:
      'Este assunto deve ser utilizado exclusivamente para processos licitatórios presenciais, com o objetivo de viabilizar a fase externa do procedimento. <br><br> Para dar continuidade ao cadastro do processo, é imprescindível que todos os itens estejam em conformidade e que o aceite seja registrado clicando no botão "Estou ciente". <br><br> Conforme estabelecido na <a href="https://backend-tramitador-seplag.s3.sa-east-1.amazonaws.com/law/IN_Conjunta_Seplag_PGE_n_01-2024_-_Licita%C3%A7%C3%B5es_presenciais_-_Suite.pdf" target="_blank" rel="noopener help" class="is-underlined has-text-color-6">Instrução Normativa Conjunta Seplag/PGE nº 001/2024</a>, de 30 de outubro de 2024, esse termo de aceite será anexado automaticamente como parte integrante do documento do <b>processo que deverá ser enviado via Suite e de forma física à Central de Licitações (PGE/Celic)</b>.'
  },

  ProcessPainelScreen: {
    ARCHIVED: "Arquivados",
    DESCRIPTION: "Descrição",
    FAVORITES: "Favoritos",
    IN_ANALYSIS: "Em Análise",
    IN_DRAFTS: "Rascunhos",
    IN_SECTOR: "No Setor",
    MY_PROCESSES: "Meus Processos",
    PROCESSED: "Tramitados",
    RETURNED: "Devolvido",
    TRAMITED_TO_ORIGIN: "Tramitado à origem",
    SIGNATURES: "Assinaturas"
  },

  ProcessViewer: {
    COMPLETE_FILE: "PDF do processo",
    VIEW_COMPLETE_FILE: "Visualizar PDF do processo",
    DOWNLOAD_FAIL: "Erro ao baixar",
    MESSAGE_COMPLETE_FILE:
      "Clique para visualizar o compilado dos documentos do processo em um único arquivo PDF.",
    MESSAGE_NEW_VIEWER:
      "Confira a nova forma de visualizar e navegar pelo processo em árvore de documentos agrupados pelo setor responsável pela inclusão.",
    MODAL_1: {
      CHANGED_VIEW: "A visualização do processo mudou!",
      INFO_TEXT:
        "Agora você pode navegar pela árvore de documentos do processo, agrupados por setor responsável pela inclusão e ordenados por número do documento.",
      ACTION_OPTIONS: "Veja algumas ações que você pode fazer:",
      HTML_INFO_EXPAND:
        "Para <span class='has-text-color-5 has-text-weight-semibold'>acessar os documentos na lista lateral</span> (árvore), você pode clicar no ícone (ICON) para ver os documentos incluídos por cada unidade.",
      HTML_INFO_ESPECIFIC:
        "Para <span class='has-text-color-5 has-text-weight-semibold'>visualizar um documento específico</span>, basta clicar no nome dele na listagem da árvore de unidades e documentos.",
      HTML_INFO_DOWNLOAD:
        'Você também pode clicar no botão "Baixar PDF do processo" para <span class="has-text-color-5 has-text-weight-semibold">acessar a versão compilada dos documentos</span> no seu computador.',
      HTML_INLINE_ICON:
        "<span class='icon (COLOR) is-small'><i class='mdi mdi-plus-box-outline'></i></span>"
    },
    MODAL_2: {
      INFO_TEXT_1:
        "A nova tela de visualização <span class='has-text-color-5 has-text-weight-semibold'>permite navegar pela árvore de documentos do processo</span>, agrupados por setor responsável pela inclusão e ordenados por número do documento.",
      INFO_TEXT_2:
        "Observamos que o <b>PDF completo do processo (PDFzão) ainda estará disponível para <i>download</i></b> por meio de botão no topo da nova tela, exceto para processos com tamanho total superior ao limite máximo (800MB).",
      INFO_TEXT_3:
        "Essa alteração visa otimizar o tempo de resposta no acesso ao processo e propiciar mais fluidez e rastreabilidade na visualização do PDF dos documentos.",
      NEW_PROCESS_VIEWER: "Nova tela de visualização de documentos do processo"
    },
    NOTICE: {
      BEFORE_ICON: "Clique no",
      AFTER_ICON: "para ver os documentos"
    },
    RETURN_DETAILS: "Detalhamento do processo",
    SNACK_DESCRIPTION:
      "O processo será baixado automaticamente quando sua criação for finalizada",
    SNACK_STEP: {
      STARTING: "Iniciando a visualização do PDF do processo",
      MERGE: "Unificando documentos do processo",
      FINISH: "Finalizando a criação do processo para visualização"
    },
    SNACK_FINISH: "Se o processo não foi aberto automaticamente",
    SNACK_TITLE: "Preparando PDF do processo (NUP)",
    SNACK_TITLE_FAIL:
      "Erro ao preparar o PDF do processo. Tente baixar novamente",
    TITLE_VIEWER: "Visualizar Documentos do Processo",
    VIEW_DOCUMENTS: "Visualizar PDF dos documentos"
  },

  ProfilesScreen: {
    ACTIVE: "Ativo",
    ARE_YOU_SURE_DELETE_PROFILE:
      "Tem certeza que deseja excluir os dados desse perfil?",
    ASSIGNER_PROFILES: {
      CAPACITY_ADM: "Administrador de unidade",
      PART_ADM: "Administrador setorial"
    },
    CLONE_PROFILE: "Clonar perfil",
    EDIT_PROFILE: "Editar Perfil",
    MESSAGES: {
      INSERT_NAME: "Insira um nome para o perfil",
      INSERT_PART:
        "Usuário não pode criar perfil sem lotações configuradas no órgão",
      INSERT_PERMISSIONS: "Insira uma ou mais permissões para o perfil"
    },
    NEW_PROFILE: "Novo perfil",
    PERMISSIONS_MANAGEMENT: "Gestão de permissões",
    PLACEHOLDERS: {
      CLONE: "Digite para pesquisar os perfis existentes",
      INSERT_KEYWORDS: "Insira palavra(s)-chave",
      INSERT_PROFILE_NAME: "Insira o nome do perfil",
      SEARCH_BY: "Pesquise por nome do perfil",
      FILTER_PERMISSIONS: "Digite para pesquisar permissões",
      FILTER_PROFILES: "Selecione um perfil atribuidor"
    },
    PROFILE_APPLICABLE_ALL_PARTS: "Tornar perfil aplicável a todos os órgãos",
    SELECT_ALL: "Selecionar todos",
    UNCHECK_ALL: "Desmarcar todos",
    NO_SUITE_ACCESS:
      "Essa lotação não possui permissão de acesso ao Suite. Necessário solicitar acesso via SSA."
  },

  ProgressBar: {
    HELP_INFORMATION_1: "O tamanho máximo do processo é de 800MB.",
    HELP_INFORMATION_2:
      "Após esse limite, novos documentos não poderão ser criados e/ou anexados ao processo.",
    WARNING_50_BAR:
      "Atenção! O processo atingiu 50% do tamanho total permitido",
    WARNING_75_BAR:
      "Atenção! O processo atingiu 75% do tamanho total permitido",
    WARNING_100_BAR:
      "Atenção! O processo atingiu 100% do tamanho total permitido"
  },

  ReportsScreen: {
    EXPORT_REPORT: "Exportar Relatório",
    FILTERS: "Filtros",
    INFORM_DATE: "Digite datas válidas para o início e o final.",
    INFORM_TYPE: "Selecione um tipo de relatório.",
    REPORTS: "Relatórios",
    REPORTS_CONFIGURATION: "Configurações de Relatórios",
    REPORT_TYPE: "Tipo de relatório"
  },

  STATUS_FILTER: {
    IN_ANALYSIS: {
      name: "Em análise",
      value: "IN_ANALYSIS"
    },
    IN_AUTO_PROCESS: {
      name: "Tramitação automática ativada",
      value: "IN_AUTO_PROCESS"
    },
    WITHOUT_AUTO_PROCESS: {
      name: "Sem tramitação automática",
      value: "WITHOUT_AUTO_PROCESS"
    },
    WITHOUT_RESPONSIBLE: {
      name: "Sem responsável",
      value: "WITHOUT_RESPONSIBLE"
    },
    MIGRATE: {
      name: "Migrado",
      value: "MIGRATE"
    },
    RETURNED: {
      name: "Devolvido",
      value: "RETURNED"
    },
    ARCHIVED: {
      name: "Arquivado",
      value: "ARCHIVED"
    },
    UNARCHIVED: {
      name: "Desarquivado",
      value: "UNARCHIVED"
    }
  },

  STATUS_SIGNATURE: {
    IS_PENDING: {
      name: "Pendente",
      value: "IS_PENDING"
    },
    IS_REFUSED: {
      name: "Recusado",
      value: "IS_REFUSED"
    },
    IS_SIGNED: {
      name: "Assinado",
      value: "IS_SIGNED"
    }
  },

  SUBJECT_CATEGORY: {
    NAME_FILE: "assuntos.xls"
  },

  UserConfig: {
    BOOKMARKERS: "Marcadores",
    MY_PROFILE: "Meu perfil",
    NOTIFICATIONS: "Notificações",
    NOTIFICATIONS_PREFERENCES: "Preferências de notificações",
    USER_CONFIGS: "Configurações de usuário"
  },

  UserManagementScreen: {
    CAPACITY_DATA: "Lotações do Usuário",
    DISABLE_BOND: "Desabilitada",
    EDIT_PROFILE: "Editar Usuário",
    ENABLE_BOND: "Habilitada",
    MAIN_CAPACITY: "Lotação Principal",
    PROFILE_DATA: "Dados do Usuário",
    SEARCH_CPF_ORGAN_ENTITY_CONSULT_USERS:
      "Busque pelo cpf, nome e órgão/entidade para consultar e editar usuários.",
    SECONDARY_CAPACITY: "Lotação Secundária",
    USER_PROFILE: "Meu Usuário"
  },

  UserSearchScreen: {
    ACTIVE: "Ativo",
    NON_ACTIVE: "Não ativo",
    SUITE_ACCESS: "Acesso Suite"
  },

  ValidateDocument: {
    CREATED_AT: "Criado em",
    DESCRIPTION:
      "Verifique e valide a autenticidade de um documento assinado no Suite",
    DOCUMENT_STATUS_VALID: "Documento válido!",
    INTERNAL_DESCRIPTION:
      "Verifique aqui a autenticidade de um documento digital assinado no Sistema Único Integrado de Tramitação Eletrônica",
    INTERNAL_TITLE: "Verificação de documento",
    LABEL_INPUT: "Código de verificação do documento",
    PLACEHOLDER:
      "Insira um código de verificação (O código fica na última página do documento)",
    SIGNED_BY: "Assinado por",
    TITLE: "Verificar Documento",
    VALIDATE_BUTTON: "Verificar",
    VERIFICATION_CODE: "Código de verificação",
    VERIFY_BUTTON: "Verificar"
  },

  Version: {
    IMPROVEMENTS_AND_FIXES: "Melhorias e correções de erros",
    NEW_FUNCTIONALITIES: "Novas funcionalidades",
    NO_VERSIONS: "Nenhuma versão encontrada",
    TITLE: "A versão mais recente do sistema foi atualizada dia",
    TITLE_PAGE: "Histórico de versões",
    VERSIONS: "Versões",
    VIEW_ALL: "Visualizar tudo",
    VIEW_HISTORY: "Visualizar histórico de versões"
  }
});

export const Home = Object.freeze({
  ACCESS: "Acesso",
  ACCESSIBILITY: "Acessibilidade",
  ACCESS_SYSTEM: "Acessar o sistema",
  COMMON_QUESTIONS: "Perguntas Frequentes",
  COMMON_QUESTIONS_ABOUT_SYSTEM: "Perguntas frequentes sobre o Suite",
  CONSULT_PROCESS: "Consultar processo",
  DIGITAL_CERT: "CERTIFICADO DIGITAL",
  DOC_LESGILATION: "Legislações referentes ao Suite",
  DOC_LESGILATION_GOV: "Legislações referentes ao Governo Digital",
  DOC_SYSTEM: "Documentação do sistema Suite",
  FORGOT_PASSWORD: "Esqueceu a senha?",
  GOVERNMENT_PORTAL: "Portal do governo",
  GOVERNMENT_PORTAL_LINK: "https://www.ceara.gov.br",
  HELP_CENTER: "Material de apoio",
  HELP_CENTER_DESCRIPTION:
    "Navegue pelos tópicos da Central de Ajuda do Suite.",
  HOME: "Início",
  IF_YOU_WANT_TO_RETURN:
    "Se deseja retornar ao sistema, clique no botão abaixo.",
  LEGISLATIONS: "Legislações",
  LOG_IN: "ENTRAR",
  OR: "Ou",
  SEARCH: "PESQUISAR",
  SELECT_CERTIFICATE_SING_IN: "Selecione um certificado para entrar",
  SEPLAG_ACCESSIBILITY: "Acessibilidade - 0800 275 0022",
  SEPLAG_ADDRESS: "Av. Ministro José Américo, S/N - Cambeba",
  SEPLAG_ADDRESS_COMPLEMENT: "Fortaleza - CE",
  SEPLAG_ADDRESS_COMPLEMENT_CEP: "Cep: 60.822-325",
  SEPLAG_CA: "Central de Atendimento - 155",
  SEPLAG_FACEBOOK: "https://www.facebook.com/seplag.ce/",
  SEPLAG_FULL_NAME: "SEPLAG - Secretaria de Planejamento e Gestão",
  SEPLAG_HELP_CENTER_SITE_LINK: "https://suite.seplag.ce.gov.br/",
  SEPLAG_INSTAGRAM: "https://www.instagram.com/seplagce/?hl=pt-br",
  SEPLAG_SCHEDULE: "Horário: 8h às 12 e 13h às 17h",
  SEPLAG_SITE: "www.seplag.ce.gov.br",
  SEPLAG_SITE_DS: "Site da Secretaria do Planejamento e Gestão",
  SEPLAG_SITE_LABEL: "SITE SEPLAG",
  SEPLAG_SITE_LINK: "https://www.seplag.ce.gov.br",
  SEPLAG_TWITTER: "https://twitter.com/seplagceara",
  SLOGAN: "Digitalizando processos. Otimizando seu tempo.",
  SOCIAL_NETWORKS: "Redes Sociais",
  USEFUL_LINKS: "Links úteis",
  VALIDATION: "Verificar documento",
  VERSION_HISTORY: "Histórico de versões",
  YOU_ARE_CONNECTED: "Você está conectado!",

  DocumentValidateScreen: {
    DOCUMENT_VERIFICATION: "Verificação do documento"
  },

  FaqCollapse: {
    HOW_RECOVEY: {
      TITLE: "Como recuperar minha senha?",
      TEXT:
        "Se você esqueceu a sua senha, clique na opção “Recuperar Senha” na página principal. Uma mensagem será encaminhada para sua conta de email com as orientações para a redefinição da senha."
    },
    HOW_ACCESS_SYSTEM: {
      TITLE: "Como eu tenho acesso ao sistema?",
      TEXT:
        "Entre em contato com o Administrador Setorial do seu órgão/entidade, para realizar o cadastro que possibilita o acesso ao sistema."
    },
    WHAT_IS_CERTIFICATE_ACCESS: {
      TITLE: "O que é o “Acesso com Certificado”?",
      TEXT:
        "O acesso com o Certificado digital, que é um arquivo eletrônico, possibilita a identificação virtual de uma pessoa física ou jurídica. Ao ser reconhecida pelo sistema, é permitida a realização das transações online com garantia de autenticidade e proteção na troca de informações."
    },
    HOW_CHANGE_USER_PROFILE: {
      TITLE: "Como mudar meu perfil de usuário?",
      TEXT:
        "Após fazer o acesso, na barra superior do sistema, no canto direito, clique na opção referente a selecionar o perfil do usuário e a sua lotação."
    },
    HOW_GET_DIGITAL_CERTIFICATE: {
      TITLE: "Como eu consigo um certificado digital?",
      TEXT:
        "Para obter um certificado digital, o usuário deve procurar o Administrador Setorial ou área de TI do seu órgão/entidade para obter maiores informações."
    }
  },

  Feedback: {
    TYPES: {
      SUGESTION: "Sugestão",
      PRAISE: "Elogio",
      BUSGS: "Erros",
      GENERAL_COMMENTS: "Comentários gerais"
    },
    REFERENCES: {
      OPEN_PROCESS: "Abrir processo",
      PANEL: "Painel",
      PROCESS_DASHBOARD: "Painel de processos",
      UNDER_REVIEW_PROCESS: "Em análise - Painel de processos",
      TO_SUBSCRIBE_PROCESS: "Para Assinar - Painel de processos",
      DRAFT_PROCESS: "Rascunho - Painel de processos",
      FAVORITES_PROCESS: "Favoritos- Painel de processos",
      SECTOR_PROCESS: "No setor - Painel de processos",
      PROCESSED_PROCESS: "Tramitados - Painel de processos",
      ARCHIVED_PROCESS: "Arquivados - Painel de processos",
      BASIC_DATA_PROCESS: "Dados Básicos - Detalhamento do processo",
      DOCUMENTS_PROCESS: "Documentos- Detalhamento do processo",
      DISPATCH: "Despacho - Detalhamento do processo",
      JOINED: "Juntada - Detalhamento do processo",
      TIMELINE: "Linha do Tempo - Detalhamento do processo",
      SEARCH: "Busca",
      MY_USER_AREA: "Minha área de usuário",
      WEBSITE_AND_OTHERS: "Site e Outros"
    },
    MESSAGES: {
      DESCRIPTION:
        "Registre sugestões, elogios e/ou comentários em geral referente ao sistema. É possível também relatar algum erro encontrado.<br /> O seu comentário ajudará na melhoria do sistema.<br /><br /> Sua opinião é muito valiosa e importante para nós!",
      FILE_ATTACHED: "Arquivo adicionado",
      FILE_IS_LARGER_THAN: "O arquivo é maior que",
      FILE_NOT_IS_ACCEPTED_TYPE: "O arquivo não é do tipo válido"
    }
  },

  Footer: {
    ALT: {
      LOGO_SEPLAG_DESCRIPTION: "Logo da Secretaria de Planejamento e Gestão"
    },
    ARIA: {
      FACEBOOK: "Acesse o Facebook da SEPLAG",
      INSTAGRAM: "Acesse o Instagram da SEPLAG",
      TWITTER: "Acesse o Twitter da SEPLAG"
    }
  },

  Login: {
    LOGO_STATE_DESCRIPTION:
      "Logo do Governo do Estado do Ceará e Projeto Papel Zero",
    LOGO_SUITE_DESCRIPTION: "Logomarca do sistema Suite",
    SUITE_USES_GUARDIAN_LOGIN:
      "O acesso ao Suite utiliza as mesmas credenciais de acesso do Guardião.",
    MESSAGES: {
      LOGIN_CREDENCIAL_INVALIDA:
        "CPF e/ou senha incorretos. Tente novamente ou entre em contato com o Administrador Setorial do seu órgão/entidade.",
      LOGIN_SISTEMA_INATIVO:
        "No momento, estamos com problemas na autenticação! Procure o administrador setorial ou tente novamente mais tarde.",
      LOGIN_VINCULO_NAO_ENCONTRADO:
        "No momento, você está sem vínculo ativo no Guardião. Entre em contato com o RH do órgão/entidade para atualizar seu cadastro e providenciar a liberação do seu acesso via Sistema de Solicitação de Acesso - SSA.",
      LOGIN_VINCULO_INATIVO:
        "No momento, você está sem vínculo ativo no Guardião. Entre em contato com o RH do órgão/entidade para atualizar seu cadastro e providenciar a liberação do seu acesso via Sistema de Solicitação de Acesso - SSA.",
      LOGIN_SENHA_EXPIRADA: "Sua senha expirou. Redefina-a e tente novamente.",
      LOGIN_EMAIL_NAO_PERMITIDO:
        "Esse domínio de e-mail não está vinculado ao CPF. Procure o RH para atualizar o e-mail no sistema.",
      LOGIN_EMAIL_NAO_ENCONTRADO:
        "Esse domínio de e-mail é inválido para acessar o sistema. Procure o RH ou entre em contato com a Central de Ajuda.",
      LOGIN_CODIGO_ENVIADO: "O código de acesso foi enviado para o seu e-mail.",
      LOGIN_CODIGO_INVALIDO: "O código de acesso é inválido. Tente novamente.",
      LOGIN_APIKEY_INVALIDA:
        "No momento, estamos com problemas na autenticação! Procure o administrador setorial ou tente novamente mais tarde.",
      GENERIC_ERROR: "Ocorreu um erro inesperado. Tente novamente.",
      RECUPERAR_SENHA_DADOS_INVALIDOS: " Preencha os campos solicitados.",
      RECUPERAR_SENHA_EMAIL_INVALIDO: "Digite o email.",
      RECUPERAR_SENHA_EMAIL_NAO_PERMITIDO:
        "Esse domínio de e-mail é inválido para acessar o sistema. Procure o RH  ou entre em contato com a Central de Ajuda.",
      RECUPERAR_SENHA_EMAIL_NAO_ENCONTRADO:
        "Não foi encontrado nenhum usuário com este e-mail. Entre em contato com o RH ou com a Central de Ajuda.",
      RECUPERAR_SENHA_CODIGO_ENVIADO:
        "O código de acesso foi enviado para o seu e-mail.",
      ALTERAR_SENHA_DADOS_INVALIDOS: "Preencha os campos solicitados.",
      ALTERAR_SENHA_HASH_INVALIDO:
        "O código inserido é inválido. Revise os dados e tente novamente.",
      ALTERAR_SENHA_SENHA_INVALIDA: "Digite a senha.",
      ALTERAR_SENHA_CONFIRMACAO_DE_SENHA_INVALIDA:
        "A confirmação de senha não confere com a senha.",
      ALTERAR_SENHA_CODIGO_INVALIDO:
        "O código inserido é inválido. Revise os dados e tente novamente.",
      ALTERAR_SENHA_SENHA_FRACA:
        "Senha fraca. A senha deve conter pelo menos 1 número, 1 caractere especial e letras maiúsculas e minúsculas."
    }
  },

  PageNotFoundScreen: {
    TITLE: "Desculpe, mas esta página não existe",
    SUBTITLE:
      "Pedimos desculpas pelo incoveniente, mas a página que você está tentando acessar não existe nesse endereço."
  },

  SearchViproc: {
    AUTHOR_FAVORED: "Autores/Favorecidos",
    PART_CAPACITY_FROM: "Órgão/Unidade de origem",
    PART_CAPACITY_TO: "Órgão/Unidade de destino",
    PROTOCOL: "Protocolo"
  },

  SuiteNumbers: {
    TITLE: "Suite em números",
    PROCESSES_OPENED: "total de processos abertos",
    PROCESS_AVERAGE: "média de processos abertos por dia",
    ACTIVE_USERS: "usuários ativos",
    ORGANS_USING: "órgãos/entidades utilizando",
    UPDATED_ON: "Atualizado em"
  },

  TopNavigationBar: {
    HIGH_CONTRAST_LABEL: "Contraste da tela",
    REDUCE_SIZE: "Diminuir a fonte",
    INCREASE_SIZE: "Aumentar a fonte",
    NORMAL_SIZE: "Fonte tamanho normal",
    ARIA: {
      ACCESS_GOV: "Acesse o portal do governo",
      ACCESS_SEPLAG: "Acesse o site da SEPLAG",
      CHANGE_HIGH_CONTRASTE: "Alternar o modo alto contraste",
      REDEFINE_TEXT_SIZE: "Redefinir o tamanho do texto",
      INCREASE_TEXT_SIZE: "Aumentar o tamanho do texto"
    },
    ALT: {
      GOV_SEPLAG: "Governo do Estado do Ceará - Projeto Papel Zero"
    }
  }
});
